"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[3757],{

/***/ 23380:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2660);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19397);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85486);
/* harmony import */ var core_js_modules_es_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_right_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62681);
/* harmony import */ var core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reverse_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60576);
/* harmony import */ var core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unscopables_flat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_unscopables_flat_map_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80754);
/* harmony import */ var core_js_modules_es_array_unscopables_flat_map_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_unscopables_flat_map_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_buffer_slice_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43070);
/* harmony import */ var core_js_modules_es_array_buffer_slice_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_buffer_slice_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_math_hypot_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98526);
/* harmony import */ var core_js_modules_es_math_hypot_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_math_hypot_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35716);
/* harmony import */ var core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_from_entries_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_promise_finally_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63896);
/* harmony import */ var core_js_modules_es_promise_finally_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_finally_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_flags_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13152);
/* harmony import */ var core_js_modules_es_regexp_flags_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_flags_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72070);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18056);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_trim_end_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8673);
/* harmony import */ var core_js_modules_es_string_trim_end_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_end_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_typed_array_float32_array_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1968);
/* harmony import */ var core_js_modules_es_typed_array_float32_array_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_float32_array_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_typed_array_float64_array_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26365);
/* harmony import */ var core_js_modules_es_typed_array_float64_array_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_float64_array_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_typed_array_int8_array_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(88104);
/* harmony import */ var core_js_modules_es_typed_array_int8_array_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_int8_array_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_typed_array_int16_array_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(32921);
/* harmony import */ var core_js_modules_es_typed_array_int16_array_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_int16_array_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_typed_array_int32_array_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(66214);
/* harmony import */ var core_js_modules_es_typed_array_int32_array_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_int32_array_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(38881);
/* harmony import */ var core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_uint8_array_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_typed_array_uint8_clamped_array_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(37924);
/* harmony import */ var core_js_modules_es_typed_array_uint8_clamped_array_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_uint8_clamped_array_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_typed_array_uint16_array_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6565);
/* harmony import */ var core_js_modules_es_typed_array_uint16_array_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_uint16_array_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_typed_array_uint32_array_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(27893);
/* harmony import */ var core_js_modules_es_typed_array_uint32_array_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_uint32_array_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(65831);
/* harmony import */ var core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_fill_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_typed_array_from_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(23697);
/* harmony import */ var core_js_modules_es_typed_array_from_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_from_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_typed_array_of_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(80088);
/* harmony import */ var core_js_modules_es_typed_array_of_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_of_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(20582);
/* harmony import */ var core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_set_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(61895);
/* harmony import */ var core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_typed_array_sort_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(60940);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_web_immediate_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(77730);
/* harmony import */ var core_js_modules_web_immediate_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_immediate_js__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_web_queue_microtask_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(93741);
/* harmony import */ var core_js_modules_web_queue_microtask_js__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_queue_microtask_js__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(91426);
/* harmony import */ var core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_js__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(71575);
/* harmony import */ var core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_to_json_js__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(17295);
/* harmony import */ var core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_js__WEBPACK_IMPORTED_MODULE_33__);




































/***/ }),

/***/ 12714:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ useLoadPolyfillsEffect)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/client/utils/useUserLanguage.jsx
var useUserLanguage = __webpack_require__(55541);
// EXTERNAL MODULE: ./node_modules/.pnpm/@formatjs+intl-pluralrules@4.1.3/node_modules/@formatjs/intl-pluralrules/should-polyfill.js
var should_polyfill = __webpack_require__(53721);
// EXTERNAL MODULE: ./node_modules/.pnpm/@formatjs+intl-getcanonicallocales@1.7.3_@types+node@18.17.17/node_modules/@formatjs/intl-getcanonicallocales/should-polyfill.js
var intl_getcanonicallocales_should_polyfill = __webpack_require__(20196);
// EXTERNAL MODULE: ./node_modules/.pnpm/@formatjs+intl-locale@2.4.37_@types+node@18.17.17/node_modules/@formatjs/intl-locale/should-polyfill.js
var intl_locale_should_polyfill = __webpack_require__(99410);
// EXTERNAL MODULE: ./node_modules/.pnpm/@formatjs+intl-numberformat@7.2.4/node_modules/@formatjs/intl-numberformat/should-polyfill.js
var intl_numberformat_should_polyfill = __webpack_require__(16415);
// EXTERNAL MODULE: ./node_modules/.pnpm/@formatjs+intl-datetimeformat@4.2.4/node_modules/@formatjs/intl-datetimeformat/should-polyfill.js
var intl_datetimeformat_should_polyfill = __webpack_require__(71176);
// EXTERNAL MODULE: ./node_modules/.pnpm/@formatjs+intl-relativetimeformat@9.5.2/node_modules/@formatjs/intl-relativetimeformat/should-polyfill.js
var intl_relativetimeformat_should_polyfill = __webpack_require__(52037);
;// CONCATENATED MODULE: ./src/client/polyfills/intlPolyfills.ts






async function polyfillPluralRules(locale) {
  if (!(0,should_polyfill.shouldPolyfill)(locale)) {
    return;
  }
  await Promise.all(/* import() | intl-pluralrules_polyfill */[__webpack_require__.e(2461), __webpack_require__.e(9133)]).then(__webpack_require__.bind(__webpack_require__, 35262));
  switch (locale.split("-").shift()) {
    default:
      await __webpack_require__.e(/* import() */ 5265).then(__webpack_require__.t.bind(__webpack_require__, 35265, 23));
      break;
    case "fr":
      await __webpack_require__.e(/* import() */ 4876).then(__webpack_require__.t.bind(__webpack_require__, 4876, 23));
      break;
    case "es":
      await __webpack_require__.e(/* import() */ 8299).then(__webpack_require__.t.bind(__webpack_require__, 18299, 23));
      break;
  }
}
async function polyfillCanonicalLocales() {
  if ((0,intl_getcanonicallocales_should_polyfill.shouldPolyfill)()) {
    await Promise.all(/* import() | intl-getcanonicallocales_polyfill */[__webpack_require__.e(9909), __webpack_require__.e(1942)]).then(__webpack_require__.bind(__webpack_require__, 45815));
  }
}
async function polyfillIntl() {
  if ((0,intl_locale_should_polyfill.shouldPolyfill)()) {
    await Promise.all(/* import() */[__webpack_require__.e(9909), __webpack_require__.e(2461), __webpack_require__.e(5310)]).then(__webpack_require__.bind(__webpack_require__, 5310));
  }
}
async function polyfillNumberFormat(locale) {
  locale = locale.toLowerCase();
  if (!(0,intl_numberformat_should_polyfill.shouldPolyfill)(locale)) {
    return;
  }
  await Promise.all(/* import() */[__webpack_require__.e(7842), __webpack_require__.e(5589)]).then(__webpack_require__.bind(__webpack_require__, 25589));
  switch (locale) {
    default:
      await __webpack_require__.e(/* import() */ 5162).then(__webpack_require__.t.bind(__webpack_require__, 5162, 23));
      break;
    case "en-gb":
      await __webpack_require__.e(/* import() */ 6429).then(__webpack_require__.t.bind(__webpack_require__, 16429, 23));
      break;
    case "fr":
      await __webpack_require__.e(/* import() */ 5903).then(__webpack_require__.t.bind(__webpack_require__, 35903, 23));
      break;
    case "es":
      await __webpack_require__.e(/* import() */ 9682).then(__webpack_require__.t.bind(__webpack_require__, 59682, 23));
      break;
    case "es-mx":
      await __webpack_require__.e(/* import() */ 5321).then(__webpack_require__.t.bind(__webpack_require__, 65321, 23));
      break;
  }
}
async function polyfillDateTimeFormat(locale) {
  locale = locale.toLowerCase();
  if (!(0,intl_datetimeformat_should_polyfill.shouldPolyfill)(locale)) {
    return;
  }
  await Promise.all(/* import() */[__webpack_require__.e(7842), __webpack_require__.e(995)]).then(__webpack_require__.bind(__webpack_require__, 40995));
  const dataPolyfills = [__webpack_require__.e(/* import() */ 162).then(__webpack_require__.t.bind(__webpack_require__, 30162, 23))];
  switch (locale) {
    default:
      dataPolyfills.push(
        __webpack_require__.e(/* import() */ 6922).then(__webpack_require__.t.bind(__webpack_require__, 66922, 23))
      );
      break;
    case "en-gb":
      dataPolyfills.push(
        __webpack_require__.e(/* import() */ 3731).then(__webpack_require__.t.bind(__webpack_require__, 3731, 23))
      );
      break;
    case "fr":
      dataPolyfills.push(
        __webpack_require__.e(/* import() */ 3213).then(__webpack_require__.t.bind(__webpack_require__, 13213, 23))
      );
      break;
    case "es-mx":
      dataPolyfills.push(
        __webpack_require__.e(/* import() */ 2323).then(__webpack_require__.t.bind(__webpack_require__, 42323, 23))
      );
      break;
    case "es":
      dataPolyfills.push(
        __webpack_require__.e(/* import() */ 8026).then(__webpack_require__.t.bind(__webpack_require__, 68026, 23))
      );
      break;
  }
  await Promise.all(dataPolyfills);
}
async function polyfillRelativeTimeFormat(locale) {
  if (!intl_relativetimeformat_should_polyfill.shouldPolyfill) {
    return;
  }
  locale = locale.toLowerCase();
  await __webpack_require__.e(/* import() */ 5837).then(__webpack_require__.bind(__webpack_require__, 55837));
  switch (locale) {
    case "en-gb":
      await __webpack_require__.e(/* import() */ 8764).then(__webpack_require__.t.bind(__webpack_require__, 88764, 23));
      break;
    case "fr":
      await __webpack_require__.e(/* import() */ 207).then(__webpack_require__.t.bind(__webpack_require__, 70207, 23));
      break;
    case "es-mx":
      await __webpack_require__.e(/* import() */ 2469).then(__webpack_require__.t.bind(__webpack_require__, 82469, 23));
      break;
    case "es":
      await __webpack_require__.e(/* import() */ 8786).then(__webpack_require__.t.bind(__webpack_require__, 18786, 23));
      break;
    default:
      await __webpack_require__.e(/* import() */ 7202).then(__webpack_require__.t.bind(__webpack_require__, 27202, 23));
  }
}
const getIntlPolyfills = (locale) => [
  polyfillPluralRules(locale),
  polyfillCanonicalLocales(),
  polyfillIntl(),
  polyfillNumberFormat(locale),
  polyfillDateTimeFormat(locale),
  polyfillRelativeTimeFormat(locale)
];
/* harmony default export */ const intlPolyfills = (getIntlPolyfills);

;// CONCATENATED MODULE: ./src/client/polyfills/index.ts

/* harmony default export */ const polyfills = ((locale = "en") => [...intlPolyfills(locale)]);

;// CONCATENATED MODULE: ./src/client/polyfills/useLoadPolyfillsEffect.js



function useLoadPolyfillsEffect() {
  const [polyfillsLoaded, setPolyfillsLoaded] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    const browserLanguage = (0,useUserLanguage/* getBrowserLanguage */.v0)();
    Promise.all(polyfills(browserLanguage)).catch((error) => {
      console.warn("Failed fetching polyfills", { error });
    }).finally(() => {
      setPolyfillsLoaded(true);
    });
  }, []);
  return polyfillsLoaded;
}


/***/ }),

/***/ 48645:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": () => (/* binding */ useCurrencyFormat),
  "YQ": () => (/* binding */ useConvertFromPenceFactory),
  "Pt": () => (/* binding */ useConvertFromPoundsFactory)
});

// UNUSED EXPORTS: LOCALE_LANG, penceToPounds, poundsToPence

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/decimal.js-light@2.5.1/node_modules/decimal.js-light/decimal.js
var decimal = __webpack_require__(97290);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+config-provider@2.1.0_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/config-provider/dist/module.js
var dist_module = __webpack_require__(23198);
;// CONCATENATED MODULE: ./src/client/price-list/constants.ts
const TERRITORY = {
  KENYA: "kenya",
  LEBANON: "lebanon",
  GHANA: "ghana",
  NIGERIA: "nigeria",
  PAKISTAN: "pakistan"
};

;// CONCATENATED MODULE: ./src/client/price-list/currencies.ts




var LOCALE_LANG = /* @__PURE__ */ ((LOCALE_LANG2) => {
  LOCALE_LANG2["EN_NG"] = "en-NG";
  LOCALE_LANG2["FR_LB"] = "fr-LB";
  LOCALE_LANG2["EN_KE"] = "en-KE";
  LOCALE_LANG2["EN_GH"] = "en-GH";
  LOCALE_LANG2["EN_PK"] = "en-PK";
  return LOCALE_LANG2;
})(LOCALE_LANG || {});
function useLocalisedCurrency() {
  const config = (0,dist_module/* useConfig */.ZR)();
  const { territory } = config;
  if (!territory) {
    throw new Error(
      "Territory unknown - cannot determine currency. Please contact support."
    );
  }
  const currencyMap = {
    [TERRITORY.NIGERIA]: {
      format: {
        compact: false,
        locale: "en-NG" /* EN_NG */
      },
      decimal: 2,
      code: "NGN",
      uuid: "6ae235f2-e345-404a-aab4-4e43f4faac5f"
    },
    [TERRITORY.LEBANON]: {
      format: {
        compact: true,
        locale: "fr-LB" /* FR_LB */
      },
      decimal: 0,
      code: "LBP",
      uuid: "1ec094ae-eff2-4dfd-b916-a5bc864183df"
    },
    [TERRITORY.KENYA]: {
      decimal: 2,
      code: "KES",
      format: {
        compact: true,
        locale: "en-KE" /* EN_KE */
      },
      uuid: "6d300ea6-8421-4678-88ad-7c33a71bb877"
    },
    [TERRITORY.GHANA]: {
      format: {
        compact: false,
        locale: "en-GH" /* EN_GH */
      },
      decimal: 2,
      code: "GHS",
      uuid: "cf7ddcd6-e35a-48cd-9471-7e3e9f9d2e59"
    },
    [TERRITORY.PAKISTAN]: {
      decimal: 2,
      format: {
        compact: false,
        locale: "en-PK" /* EN_PK */
      },
      code: "PKR",
      uuid: "d38472d2-02e8-437a-b55a-565e19516c8a"
    }
  };
  const currency = currencyMap[territory];
  if (!currency) {
    throw new Error(
      "No currency supported for this territory. Please contact support."
    );
  }
  return currency;
}
function useCurrencyFormat(overrideCurrency) {
  const billingCurrency = useLocalisedCurrency();
  const currency = overrideCurrency != null ? overrideCurrency : billingCurrency;
  return (0,react.useMemo)(() => {
    if (!(currency == null ? void 0 : currency.format)) {
      return void 0;
    }
    const digits = 2;
    return new Intl.NumberFormat(currency.format.locale, {
      style: "currency",
      currency: currency.code,
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    });
  }, [currency]);
}
const CURRENCY_BASE_DEFAULT = 10;
const DECIMALS_PLACES_DEFAULT = 2;
const penceToPounds = (currency) => (amountInPence) => {
  var _a;
  if (!amountInPence && amountInPence !== 0) {
    return void 0;
  }
  const currencyDecimals = (_a = currency == null ? void 0 : currency.decimal) != null ? _a : DECIMALS_PLACES_DEFAULT;
  const amountInPenceDecimal = new decimal.Decimal(amountInPence);
  return amountInPenceDecimal.div(CURRENCY_BASE_DEFAULT ** currencyDecimals).toNumber();
};
function useConvertFromPenceFactory() {
  const currency = useLocalisedCurrency();
  return penceToPounds(currency);
}
const poundsToPence = (currency) => (amountInPounds) => {
  var _a;
  if (!amountInPounds && amountInPounds !== 0) {
    return void 0;
  }
  const currencyDecimals = (_a = currency == null ? void 0 : currency.decimal) != null ? _a : DECIMALS_PLACES_DEFAULT;
  const amountInPoundsDecimal = new decimal.Decimal(amountInPounds);
  return amountInPoundsDecimal.mul(CURRENCY_BASE_DEFAULT ** currencyDecimals).toInteger().toNumber();
};
function useConvertFromPoundsFactory() {
  const currency = useLocalisedCurrency();
  return poundsToPence(currency);
}


/***/ }),

/***/ 90827:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EF": () => (/* binding */ linkToPriceList),
/* harmony export */   "LF": () => (/* binding */ linkToAddPrices),
/* harmony export */   "M6": () => (/* binding */ linkToCreateCustomItems),
/* harmony export */   "o0": () => (/* binding */ linkToPriceListHome),
/* harmony export */   "xV": () => (/* binding */ linkToCreatePriceList)
/* harmony export */ });
function linkToPriceListHome() {
  return "/price-list";
}
function linkToCreatePriceList() {
  return `${linkToPriceListHome()}/create`;
}
function linkToPriceList(priceListId = ":id") {
  return `${linkToPriceListHome()}/${priceListId}`;
}
function linkToAddPrices(priceListId = ":id", queryParams) {
  const baseUrl = `${linkToPriceList(priceListId)}/add-prices`;
  if (!queryParams) {
    return baseUrl;
  }
  const queryStr = new URLSearchParams(queryParams).toString();
  return `${linkToPriceList(priceListId)}/add-prices?${queryStr}`;
}
function linkToCreateCustomItems(priceListId = ":id") {
  return `${linkToPriceList(priceListId)}/create-custom-items`;
}


/***/ }),

/***/ 67891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ printing_useThermalPrinter)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/escpos-buffer@2.0.1/node_modules/escpos-buffer/dist/index.js
var dist = __webpack_require__(46721);
;// CONCATENATED MODULE: ./src/client/printing/fakePrinter.ts

const fakePrinterEnabled = () => !!localStorage.getItem("fakePrinter.enabled");
const fakePrinterAuthorised = () => !!localStorage.getItem("fakePrinter.authorised");
const setFakePrinterAuthorised = () => localStorage.setItem("fakePrinter.authorised", "true");
function authoriseFakePrinter() {
  if (!fakePrinterAuthorised()) {
    if (!confirm("Authorise FakePrinter?")) {
      throw new Error("No FakePrinter Chosen");
    }
    setFakePrinterAuthorised();
  }
}
class FakePrinter extends dist.Printer {
  constructor() {
    super(...arguments);
    this.lines = [];
  }
  async delay(n = 1) {
    return new Promise((resolve) => setTimeout(() => resolve(null), n));
  }
  get columns() {
    return 50;
  }
  async writeln(text, ...args) {
    this.lines.push([`${text}
`, ...args]);
    return this.delay();
  }
  async write(...args) {
    this.lines.push(args);
    return this.delay();
  }
  async draw(image) {
    this.lines.push([image]);
    return this.delay();
  }
  async feed(lines) {
    this.lines.push(...Array(lines).fill(["\n"]));
    return this.delay();
  }
  async setCodepage(_value) {
    return this.delay();
  }
  async drawer(_number, _onTime, _offTime) {
    return this.delay();
  }
  async qrcode(_data, _size) {
    this.lines.push(["<< QR Code >>\n"]);
    return this.delay();
  }
  async buzzer() {
    this.lines.push(["-----BUZZ-----"]);
    return this.delay();
  }
  async cutter() {
    this.lines.push(["-----CUT-----"]);
    console.log(this.lines);
    await this.delay(500);
    this.lines = [];
  }
  async close() {
    this.lines = [];
    return this.delay();
  }
  async setAlignment() {
    return this.delay();
  }
}

;// CONCATENATED MODULE: ./src/client/printing/getPrinter.ts


const COMMUNICATIONS_AND_CDC_CLASS = 2;
const PRINTER_CLASS = 7;
class WebUSBNotSupportedError extends Error {
  constructor() {
    super(
      "This browser cannot support thermal printing. Please use latest Chrome"
    );
  }
}
async function setup(device) {
  if (fakePrinterEnabled()) {
    return new FakePrinter(null);
  }
  const connection = new dist.WebUSB(device);
  return dist.Printer.CONNECT("TM-T20", connection);
}
async function havePreviousPrinter() {
  if (!("usb" in navigator))
    throw new WebUSBNotSupportedError();
  try {
    if (fakePrinterEnabled()) {
      return fakePrinterAuthorised();
    }
    const [device] = await navigator.usb.getDevices();
    return !!device;
  } catch (e) {
    return false;
  }
}
async function getPreviousPrinter() {
  if (!("usb" in navigator))
    throw new WebUSBNotSupportedError();
  if (fakePrinterEnabled()) {
    if (fakePrinterAuthorised()) {
      const res2 = await setup(null);
      return res2;
    }
    return null;
  }
  const [device] = await navigator.usb.getDevices();
  if (!device)
    return null;
  const res = await setup(device);
  return res;
}
async function authorisePrinter() {
  if (!("usb" in navigator))
    throw new WebUSBNotSupportedError();
  if (fakePrinterEnabled()) {
    authoriseFakePrinter();
    const res2 = await setup(null);
    return res2;
  }
  const device = await navigator.usb.requestDevice({
    filters: [
      { classCode: PRINTER_CLASS },
      { classCode: COMMUNICATIONS_AND_CDC_CLASS }
    ]
  });
  const res = await setup(device);
  return res;
}

;// CONCATENATED MODULE: ./src/client/printing/useThermalPrinter.ts


const useThermalPrinter = () => {
  const [printer, setPrinter] = (0,react.useState)(null);
  const [error, setError] = (0,react.useState)(null);
  const getOrAuthorisePrinter = async () => {
    if (printer)
      return printer;
    try {
      let retrievedPrinter = await getPreviousPrinter();
      if (!retrievedPrinter) {
        retrievedPrinter = await authorisePrinter();
      }
      if (!retrievedPrinter) {
        setError(new Error("Could not authorise printer"));
        return null;
      }
      setPrinter(retrievedPrinter);
      return retrievedPrinter;
    } catch (e) {
      setError(e);
    }
    return null;
  };
  const print = async (func) => {
    const retrievedPrinter = await getOrAuthorisePrinter();
    if (retrievedPrinter) {
      try {
        await func(retrievedPrinter);
      } catch (e) {
        setError(e);
      }
    }
  };
  const reset = () => {
    setError(null);
  };
  const havePrinter = async () => {
    let hasPrinter = false;
    try {
      hasPrinter = await havePreviousPrinter();
    } catch (e) {
      setError(e);
    }
    return hasPrinter;
  };
  return { print, havePrinter, reset, error };
};
/* harmony default export */ const printing_useThermalPrinter = (useThermalPrinter);


/***/ }),

/***/ 55558:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76653);
/* harmony import */ var _links__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82303);



const NavigateHome = (delegateProps) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .Navigate */ .Fg, {
    to: (0,_links__WEBPACK_IMPORTED_MODULE_2__/* .linkToHome */ .J4)(),
    ...delegateProps
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NavigateHome);


/***/ }),

/***/ 62205:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var elephant_web_client_utils_useUserRole__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67858);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76653);
/* harmony import */ var _links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82303);




const RequireAuth = ({ children = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Outlet */ .j3, null), only, except }) => {
  const userRole = (0,elephant_web_client_utils_useUserRole__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  if (only && except) {
    throw new Error("Please specify only either only or except.");
  }
  let isAuthorised = true;
  if (only) {
    isAuthorised = only.includes(userRole);
  }
  if (except) {
    isAuthorised = !except.includes(userRole);
  }
  if (!userRole) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Navigate */ .Fg, {
      to: (0,_links__WEBPACK_IMPORTED_MODULE_3__/* .linkToSignOut */ .Af)()
    });
  }
  if (!isAuthorised) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Navigate */ .Fg, {
      to: (0,_links__WEBPACK_IMPORTED_MODULE_3__/* .linkToUnauthorized */ .gr)()
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RequireAuth);


/***/ }),

/***/ 58264:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JZ": () => (/* binding */ useLocationHistoryContext),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports MAX_LOCATION_HISTORY_SIZE, LocationHistoryContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76653);


const initialEmptyState = {
  locationHistory: []
};
const MAX_LOCATION_HISTORY_SIZE = 10;
const LocationHistoryContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialEmptyState);
const LocationHistoryProvider = ({
  children
}) => {
  const location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .useLocation */ .TH)();
  const [locations, setLocations] = react__WEBPACK_IMPORTED_MODULE_0__.useState([]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => setLocations((prevState) => {
      var _a;
      if (location.pathname === ((_a = prevState[prevState.length - 1]) == null ? void 0 : _a.pathname)) {
        const newList2 = [...prevState];
        newList2[newList2.length - 1] = location;
        return newList2;
      }
      const newLocation = { ...location };
      const newList = [...prevState, newLocation];
      const trimmedList = newList.length > MAX_LOCATION_HISTORY_SIZE ? newList.slice(1, MAX_LOCATION_HISTORY_SIZE + 1) : newList;
      return trimmedList;
    }),
    [location]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LocationHistoryContext.Provider, {
    value: {
      get locationHistory() {
        return [...locations.map((l) => ({ ...l }))];
      }
    }
  }, children);
};
function useLocationHistoryContext() {
  const context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(LocationHistoryContext);
  if (context === void 0) {
    throw new Error(
      "useNavigateListener must be used within a LocationListenerProvider"
    );
  }
  return context;
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LocationHistoryProvider);


/***/ }),

/***/ 76252:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": () => (/* binding */ router)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@6.15.0_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/react-router-dom/dist/index.js
var react_router_dom_dist = __webpack_require__(58311);
// EXTERNAL MODULE: ./src/client/routes/history/LocationHistoryProvider.tsx
var LocationHistoryProvider = __webpack_require__(58264);
// EXTERNAL MODULE: ./src/client/clinical-engine/index.tsx + 13 modules
var clinical_engine = __webpack_require__(15914);
// EXTERNAL MODULE: ./src/client/components/Freshdesk/index.tsx
var Freshdesk = __webpack_require__(80545);
// EXTERNAL MODULE: ./src/client/locations/LocationsContext.tsx
var LocationsContext = __webpack_require__(85884);
// EXTERNAL MODULE: ./src/client/components/SignOut/SignOut.tsx
var SignOut = __webpack_require__(28262);
// EXTERNAL MODULE: ./src/client/auth/auth0/Auth0Login.jsx
var Auth0Login = __webpack_require__(42759);
// EXTERNAL MODULE: ./src/client/auth/auth0/Auth0Callback.tsx + 1 modules
var Auth0Callback = __webpack_require__(52437);
// EXTERNAL MODULE: ./src/client/auth/auth0/Auth0Consent.jsx + 4 modules
var Auth0Consent = __webpack_require__(58053);
// EXTERNAL MODULE: ./src/client/pages/ExternalPassport/ExternalPassport.tsx + 3 modules
var ExternalPassport = __webpack_require__(60573);
// EXTERNAL MODULE: ./src/client/pages/NotFound/NotFound.tsx
var NotFound = __webpack_require__(37371);
// EXTERNAL MODULE: ./src/client/pages/Loading/index.jsx
var Loading = __webpack_require__(79000);
// EXTERNAL MODULE: ./src/client/pages/Unauthorized/Unauthorized.jsx + 1 modules
var Unauthorized = __webpack_require__(12852);
// EXTERNAL MODULE: ./src/client/routes/RequireAuth.tsx
var RequireAuth = __webpack_require__(62205);
// EXTERNAL MODULE: ./src/client/auth/index.ts + 1 modules
var auth = __webpack_require__(89962);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./src/client/utils/useUser.ts
var useUser = __webpack_require__(91019);
// EXTERNAL MODULE: ./src/client/dev-tools/index.tsx + 1 modules
var dev_tools = __webpack_require__(49444);
// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/ClinicalSyncStatus.tsx + 1 modules
var ClinicalSyncStatus = __webpack_require__(75185);
// EXTERNAL MODULE: ./src/client/components/GlobalAppIssueOverlay/GlobalAppIssueOverlay.tsx + 5 modules
var GlobalAppIssueOverlay = __webpack_require__(64067);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+service-worker@0.2.0_react@18.1.0/node_modules/@elephant-healthcare/service-worker/dist/esm/index.js + 2 modules
var esm = __webpack_require__(17664);
// EXTERNAL MODULE: ./src/client/service-worker/useRegisterServiceWorker.tsx
var useRegisterServiceWorker = __webpack_require__(27738);
// EXTERNAL MODULE: ./src/client/utils/useUserRole.ts
var useUserRole = __webpack_require__(67858);
// EXTERNAL MODULE: ./src/client/auth/auth0/links.js
var links = __webpack_require__(81041);
;// CONCATENATED MODULE: ./src/client/routes/ServiceWorkerUpdater.tsx







function useUserHomepage() {
  var _a;
  const roleName = (0,useUserRole/* default */.Z)();
  const role = auth/* ROLES */.K$[roleName];
  return (_a = role == null ? void 0 : role.path) != null ? _a : (0,links/* linkToAuth0Login */.G2)();
}
const ServiceWorkerUpdater = react.memo(() => {
  const { pathname } = (0,dist/* useLocation */.TH)();
  const userHomepage = useUserHomepage();
  const swRegistration = (0,useRegisterServiceWorker/* useServiceWorkerRegistration */.Xq)();
  const shouldUseUpdateServiceWorker =  true && pathname === userHomepage;
  (0,esm/* useUpdateServiceWorker */.B)({
    swRegistration: shouldUseUpdateServiceWorker ? swRegistration : void 0
  });
  return null;
});
/* harmony default export */ const routes_ServiceWorkerUpdater = (ServiceWorkerUpdater);

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+config-provider@2.1.0_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/config-provider/dist/module.js
var dist_module = __webpack_require__(23198);
// EXTERNAL MODULE: ./node_modules/.pnpm/jwt-simple@0.5.6/node_modules/jwt-simple/index.js
var jwt_simple = __webpack_require__(5615);
var jwt_simple_default = /*#__PURE__*/__webpack_require__.n(jwt_simple);
// EXTERNAL MODULE: ./src/client/auth/SessionTokenProvider/SessionTokenProvider.tsx
var SessionTokenProvider = __webpack_require__(1767);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/routes/__generated__/useCheckToken.gql.ts


const defaultOptions = {};
const UserIsActiveDocument = lib/* gql */.Ps`
    query userIsActive {
  myUser {
    meta {
      active
    }
  }
}
    `;
function useUserIsActiveQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(UserIsActiveDocument, options);
}
function useUserIsActiveLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(UserIsActiveDocument, options);
}

;// CONCATENATED MODULE: ./src/client/routes/useCheckToken.ts






function decodeJwt(token) {
  return jwt_simple_default().decode(token, null, true);
}
function isValidToken(token) {
  if (!token)
    return false;
  const parsedJwt = decodeJwt(token);
  const expiry = parsedJwt.exp * 1e3;
  if (!expiry)
    return false;
  return new Date(expiry) >= new Date();
}
lib/* gql */.Ps`
  query userIsActive {
    myUser {
      meta {
        active
      }
    }
  }
`;
function useCheckToken() {
  var _a, _b, _c;
  const {
    user: { status: refreshTimeoutMinutes }
  } = (0,dist_module/* useConfig */.ZR)();
  const { sessionToken: token } = (0,SessionTokenProvider/* useSessionTokenContext */.ic)();
  const intervalRef = (0,react.useRef)();
  const { data, refetch } = useUserIsActiveQuery();
  (0,react.useEffect)(() => {
    const refreshTimeoutMs = refreshTimeoutMinutes * 60 * 1e3;
    intervalRef.current = setInterval(() => {
      refetch();
    }, refreshTimeoutMs);
    return () => clearInterval(intervalRef.current);
  }, [refreshTimeoutMinutes, refetch]);
  return isValidToken(token) && ((_c = (_b = (_a = data == null ? void 0 : data.myUser) == null ? void 0 : _a.meta) == null ? void 0 : _b.active) != null ? _c : true);
}

// EXTERNAL MODULE: ./src/client/pages/Home.tsx
var Home = __webpack_require__(80951);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var mui_toast_dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(mui_toast_dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-modal@0.3.9_vyafebljftw2lpwbgyprbkkpkm/node_modules/@elephant-healthcare/mui-modal/dist/module.js
var mui_modal_dist_module = __webpack_require__(27832);
// EXTERNAL MODULE: ./src/client/components/Layout/AppLayout.tsx
var AppLayout = __webpack_require__(34651);
// EXTERNAL MODULE: ./src/client/common/i18n/TranslationsProvider.tsx + 1 modules
var TranslationsProvider = __webpack_require__(65267);
// EXTERNAL MODULE: ./src/client/components/ErrorBoundary.tsx
var ErrorBoundary = __webpack_require__(60884);
// EXTERNAL MODULE: ./src/client/auth/auth0/Auth0Provider.jsx
var Auth0Provider = __webpack_require__(3234);
// EXTERNAL MODULE: ./src/client/auth/UserProvider.tsx
var UserProvider = __webpack_require__(54481);
// EXTERNAL MODULE: ./src/client/compatibility/BrowserSupport.tsx
var BrowserSupport = __webpack_require__(10162);
// EXTERNAL MODULE: ./src/client/components/GlobalAppIssueOverlay/Context.tsx
var Context = __webpack_require__(94693);
// EXTERNAL MODULE: ./src/client/apollo/ApolloProvider.tsx
var ApolloProvider = __webpack_require__(30668);
// EXTERNAL MODULE: ./src/client/observability/uxAnalytics/index.ts + 5 modules
var uxAnalytics = __webpack_require__(62463);
// EXTERNAL MODULE: ./src/client/observability/uxAnalytics/backgroundEmitters/NetworkBackgroundUXAnalyticEmitter.ts
var NetworkBackgroundUXAnalyticEmitter = __webpack_require__(57294);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Add.js
var Add = __webpack_require__(91136);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Link.js
var Link = __webpack_require__(97953);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/LinkOff.js
var LinkOff = __webpack_require__(70154);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-page@0.4.3_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-page/dist/index.js
var mui_page_dist = __webpack_require__(48534);
;// CONCATENATED MODULE: ./src/client/price-list/components/PageLayout/Page.tsx


const Page = (0,styled/* default */.Z)(mui_page_dist.Page)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3)
}));
/* harmony default export */ const PageLayout_Page = (Page);

;// CONCATENATED MODULE: ./src/client/price-list/components/PageLayout/index.ts


// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
;// CONCATENATED MODULE: ./src/client/price-list/pages/PriceListPage/__generated__/PriceListPage.gql.ts


const PriceListPage_gql_defaultOptions = {};
const GetPriceListDocument = lib/* gql */.Ps`
    query getPriceList($input: PriceListItemsInput!, $options: PriceListItemsOptions) {
  priceListV2 {
    priceListItems(input: $input, options: $options) {
      pageInfo {
        pageNumber
        pageSize
        totalRows
      }
      edges {
        id
        name
        externalReference {
          origin
        }
        prices {
          id
          value
          owner
          tariff {
            id
            name
          }
          revenueDepartment {
            id
            name
          }
          owner
          parentPrice {
            id
            value
            owner
            tariff {
              id
              name
            }
            revenueDepartment {
              id
              name
            }
            owner
          }
        }
      }
      meta {
        linkedToOrganisation
        facilityId
      }
    }
  }
}
    `;
function useGetPriceListQuery(baseOptions) {
  const options = { ...PriceListPage_gql_defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(GetPriceListDocument, options);
}
function useGetPriceListLazyQuery(baseOptions) {
  const options = { ...PriceListPage_gql_defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetPriceListDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-input@0.3.5_atek3e5pugfjeukz7kzynbm6iy/node_modules/@elephant-healthcare/mui-input/dist/module.js
var mui_input_dist_module = __webpack_require__(34948);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/images/warningIcon.svg
const warningIcon_namespaceObject = __webpack_require__.p + "assets/warningIcon.svg";
// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/hooks/__generated__/useTariffsQuery.gql.ts


const useTariffsQuery_gql_defaultOptions = {};
const FetchTariffsAndInsuranceProvidersDocument = lib/* gql */.Ps`
    query fetchTariffsAndInsuranceProviders {
  minInsuranceProviders {
    id
    name
  }
  priceListV2 {
    priceTariffs {
      edges {
        id
        name
        externalReference {
          foreignId
          origin
        }
      }
    }
  }
}
    `;
function useFetchTariffsAndInsuranceProvidersQuery(baseOptions) {
  const options = { ...useTariffsQuery_gql_defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(FetchTariffsAndInsuranceProvidersDocument, options);
}
function useFetchTariffsAndInsuranceProvidersLazyQuery(baseOptions) {
  const options = { ...useTariffsQuery_gql_defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(FetchTariffsAndInsuranceProvidersDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/hooks/useTariffsQuery.ts





lib/* gql */.Ps`
  query fetchTariffsAndInsuranceProviders {
    minInsuranceProviders {
      id
      name
    }
    priceListV2 {
      priceTariffs {
        edges {
          id
          name
          externalReference {
            foreignId
            origin
          }
        }
      }
    }
  }
`;
const formatInsurersName = (insurers, priceTariffs) => priceTariffs == null ? void 0 : priceTariffs.map((pt) => {
  const insurer = insurers == null ? void 0 : insurers.find(
    (i) => {
      var _a;
      return ((_a = pt == null ? void 0 : pt.externalReference) == null ? void 0 : _a.foreignId) === i.id;
    }
  );
  return {
    id: pt.id,
    name: (insurer == null ? void 0 : insurer.name) ? insurer.name : pt.name
  };
});
const usePriceTariffsQuery = () => {
  var _a, _b;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { data, loading, error } = useFetchTariffsAndInsuranceProvidersQuery();
  (0,react.useEffect)(() => {
    if (error) {
      dist_default().error(
        formatMessage(
          {
            id: "useTariffsQuery.fetchError",
            defaultMessage: "Failed to fetch price types: {error}"
          },
          { error: error.message }
        )
      );
    }
  }, [error]);
  const tariffs = formatInsurersName(
    data == null ? void 0 : data.minInsuranceProviders,
    (_b = (_a = data == null ? void 0 : data.priceListV2) == null ? void 0 : _a.priceTariffs) == null ? void 0 : _b.edges
  );
  return { tariffs, loading };
};
/* harmony default export */ const useTariffsQuery = (usePriceTariffsQuery);

// EXTERNAL MODULE: ./src/client/price-list/routing/links.ts
var routing_links = __webpack_require__(90827);
;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/AddItemsModal.tsx












const useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    alignItems: "center",
    display: "flex"
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  }
}));
const AddItemsModal = ({
  open,
  onClose,
  priceListId
}) => {
  var _a;
  const classes = useStyles();
  const navigate = (0,dist/* useNavigate */.s0)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [tariffId, setTariffId] = (0,react.useState)();
  const [origin, setOrigin] = (0,react.useState)();
  const { tariffs, loading } = useTariffsQuery();
  const originOptions = (0,react.useMemo)(
    () => [
      {
        value: base_gql/* PriceableItemOrigin.General */.l1.General,
        label: formatMessage({
          id: "priceList.addItems.itemType.general.label",
          defaultMessage: "General"
        })
      },
      {
        value: base_gql/* PriceableItemOrigin.Inventory */.l1.Inventory,
        label: formatMessage({
          id: "priceList.addItems.itemType.inventory.label",
          defaultMessage: "Inventory"
        })
      },
      {
        value: base_gql/* PriceableItemOrigin.Investigation */.l1.Investigation,
        label: formatMessage({
          id: "priceList.addItems.itemType.investigation.label",
          defaultMessage: "Investigation"
        })
      },
      {
        value: base_gql/* PriceableItemOrigin.Procedure */.l1.Procedure,
        label: formatMessage({
          id: "priceList.addItems.itemType.procedure.label",
          defaultMessage: "Procedure"
        })
      },
      {
        value: base_gql/* PriceableItemOrigin.Custom */.l1.Custom,
        label: formatMessage({
          id: "prceList.addItems.itemType.custom.label",
          defaultMessage: "Custom"
        })
      }
    ],
    [formatMessage]
  );
  const tariffOptions = (_a = tariffs == null ? void 0 : tariffs.map((i) => ({
    value: i.id,
    label: i.name
  }))) != null ? _a : [];
  const handleAdd = () => {
    if (!origin || !tariffId) {
      dist_default().error(
        "Cannot add items without selecting item type and price type."
      );
      return;
    }
    navigate((0,routing_links/* linkToAddPrices */.LF)(priceListId, { origin, tariffId }));
    onClose();
  };
  const tariffLabel = formatMessage({
    id: "pricelist.modal.addItems.reason.label",
    defaultMessage: "Select Price Type"
  });
  const originLabel = formatMessage({
    id: "pricelist.modal.addItems.reason.placeholder",
    defaultMessage: "Select Item Type"
  });
  return /* @__PURE__ */ react.createElement(mui_modal_dist_module/* Modal */.u_, {
    open
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement("img", {
    src: warningIcon_namespaceObject,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.addItems.modal.title",
    defaultMessage: "Add Items"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(mui_input_dist_module/* SelectField */.mg, {
    fullWidth: true,
    label: tariffLabel,
    options: tariffOptions,
    inputLabelProps: {
      id: "tariff"
    },
    selectProps: {
      disabled: loading,
      value: tariffId,
      "data-testid": "pricelist.add.tariff",
      onChange: (e) => setTariffId(e.target.value)
    }
  }), /* @__PURE__ */ react.createElement(mui_input_dist_module/* SelectField */.mg, {
    fullWidth: true,
    hideHelper: true,
    label: originLabel,
    options: originOptions,
    inputLabelProps: {
      id: "origin"
    },
    selectProps: {
      value: origin,
      "data-testid": "pricelist.add.origin",
      onChange: (e) => setOrigin(e.target.value)
    }
  }))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => onClose()
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.addItems.cancel",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    onClick: handleAdd,
    "data-testid": "pricelist.modal.addItems.accept",
    disabled: !origin || !tariffId
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.addItems.confirm",
    defaultMessage: "Add Items"
  })))));
};
/* harmony default export */ const Modals_AddItemsModal = (AddItemsModal);

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/__generated__/ConnectToOrgPriceListModal.gql.ts


const ConnectToOrgPriceListModal_gql_defaultOptions = {};
const ConnectOrganisationPriceListDocument = lib/* gql */.Ps`
    mutation connectOrganisationPriceList($priceListId: ID!) {
  priceListV2 {
    connectOrganisationPriceList(input: {priceListId: $priceListId}) {
      organisationPriceListId
    }
  }
}
    `;
function useConnectOrganisationPriceListMutation(baseOptions) {
  const options = { ...ConnectToOrgPriceListModal_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(ConnectOrganisationPriceListDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/ConnectToOrgPriceListModal.tsx









const ConnectToOrgPriceListModal_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    alignItems: "center",
    display: "flex"
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  }
}));
lib/* gql */.Ps`
  mutation connectOrganisationPriceList($priceListId: ID!) {
    priceListV2 {
      connectOrganisationPriceList(input: { priceListId: $priceListId }) {
        organisationPriceListId
      }
    }
  }
`;
const ConnectToOrgPriceListModal = ({
  open,
  onClose,
  priceListId,
  onCompleted
}) => {
  const classes = ConnectToOrgPriceListModal_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [connectToOrgPriceList] = useConnectOrganisationPriceListMutation();
  const handleConnect = () => {
    connectToOrgPriceList({ variables: { priceListId } }).then(() => {
      dist_default().success(
        formatMessage({
          id: "pricelist.connectToPriceList.success",
          defaultMessage: "Connected to organisation price list"
        })
      );
      onCompleted == null ? void 0 : onCompleted();
    }).catch((error) => {
      dist_default().error(error.message);
    });
    onClose();
  };
  return /* @__PURE__ */ react.createElement(mui_modal_dist_module/* Modal */.u_, {
    open
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement("img", {
    src: warningIcon_namespaceObject,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.conectToOrgPriceList.modal.title",
    defaultMessage: "Connect to Org Price List"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.conectToOrgPriceList.body",
    defaultMessage: "Connecting to your organisations price list will add new items to your price list. The prices for these items will be maintained by your organisation."
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => onClose()
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.conectToOrgPriceList.cancel",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    onClick: handleConnect,
    "data-testid": "pricelist.modal.conectToOrgPriceList.accept"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.conectToOrgPriceList.confirm",
    defaultMessage: "Connect"
  })))));
};
/* harmony default export */ const Modals_ConnectToOrgPriceListModal = (ConnectToOrgPriceListModal);

;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/__generated__/DisconnectFromOrgPriceListModal.gql.ts


const DisconnectFromOrgPriceListModal_gql_defaultOptions = {};
const DisconnectFromOrganisationPriceListDocument = lib/* gql */.Ps`
    mutation disconnectFromOrganisationPriceList($priceListId: ID!) {
  priceListV2 {
    disconnectFromOrganisationPriceList(input: {priceListId: $priceListId}) {
      priceListId
    }
  }
}
    `;
function useDisconnectFromOrganisationPriceListMutation(baseOptions) {
  const options = { ...DisconnectFromOrgPriceListModal_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(DisconnectFromOrganisationPriceListDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/DisconnectFromOrgPriceListModal.tsx









const DisconnectFromOrgPriceListModal_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    alignItems: "center",
    display: "flex"
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  }
}));
lib/* gql */.Ps`
  mutation disconnectFromOrganisationPriceList($priceListId: ID!) {
    priceListV2 {
      disconnectFromOrganisationPriceList(input: { priceListId: $priceListId }) {
        priceListId
      }
    }
  }
`;
const DisconnectFromOrgPriceListModal = ({
  priceListId,
  open,
  onClose,
  onCompleted
}) => {
  const classes = DisconnectFromOrgPriceListModal_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [disconnectFromOrgPriceList] = useDisconnectFromOrganisationPriceListMutation();
  const handleDisconnect = () => {
    disconnectFromOrgPriceList({ variables: { priceListId } }).then(() => {
      dist_default().success(
        formatMessage({
          id: "pricelist.disconnectFromPriceList.success",
          defaultMessage: "Disconnected from organisation price list"
        })
      );
      onCompleted == null ? void 0 : onCompleted();
    }).catch((e) => {
      dist_default().error(e.message);
    });
    onClose();
  };
  return /* @__PURE__ */ react.createElement(mui_modal_dist_module/* Modal */.u_, {
    open
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement("img", {
    src: warningIcon_namespaceObject,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.disconnectFromOrgPriceList.modal.title",
    defaultMessage: "Disconnect from Org Price List"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.disconnectFromOrgPriceList.description",
    defaultMessage: "Once disconnected, prices on the organisation price list will not be automatically added to invoices. If you proceed, \n              you will be able to rejoin at any time. Please confirm whether you would like to disconnect"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => onClose()
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.disconnectFromOrgPriceList.cancel",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    onClick: handleDisconnect,
    "data-testid": "pricelist.modal.disconnectFromOrgPriceList.accept"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.disconnectFromOrgPriceList.confirm",
    defaultMessage: "Disconnect"
  })))));
};
/* harmony default export */ const Modals_DisconnectFromOrgPriceListModal = (DisconnectFromOrgPriceListModal);

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var user_context_provider_dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./node_modules/.pnpm/ramda@0.27.0/node_modules/ramda/es/isEmpty.js + 1 modules
var isEmpty = __webpack_require__(3549);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash.mapvalues@4.6.0/node_modules/lodash.mapvalues/index.js
var lodash_mapvalues = __webpack_require__(40525);
var lodash_mapvalues_default = /*#__PURE__*/__webpack_require__.n(lodash_mapvalues);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Delete.js
var Delete = __webpack_require__(7056);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Undo.js
var Undo = __webpack_require__(53992);
// EXTERNAL MODULE: ./src/ex-web-packages/index.ts
var ex_web_packages = __webpack_require__(26298);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+react-hook-form-input@0.1.7_sjfm3rrfwwtsx5okgtvvldeidu/node_modules/@elephant-healthcare/react-hook-form-input/dist/module.js
var react_hook_form_input_dist_module = __webpack_require__(29054);
// EXTERNAL MODULE: ./src/client/price-list/currencies.ts + 1 modules
var currencies = __webpack_require__(48645);
;// CONCATENATED MODULE: ./src/client/price-list/pages/PriceListPage/__generated__/EditItemsTable.gql.ts


const EditItemsTable_gql_defaultOptions = {};
const RevenueDepartmentsDocument = lib/* gql */.Ps`
    query revenueDepartments {
  priceListV2 {
    revenueDepartments {
      edges {
        id
        name
      }
    }
  }
}
    `;
function useRevenueDepartmentsQuery(baseOptions) {
  const options = { ...EditItemsTable_gql_defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(RevenueDepartmentsDocument, options);
}
function useRevenueDepartmentsLazyQuery(baseOptions) {
  const options = { ...EditItemsTable_gql_defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(RevenueDepartmentsDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(81381);
;// CONCATENATED MODULE: ./src/client/price-list/components/ZeroOrGreaterMonetaryAmountInPoundsField/ZeroOrGreaterMonetaryAmountInPoundsField.tsx



function parseNumber(numberStr) {
  const floatValue = Number.parseFloat(numberStr);
  if (!Number.isNaN(floatValue)) {
    return floatValue;
  }
  const intValue = Number.parseInt(numberStr, 10);
  if (!Number.isNaN(floatValue)) {
    return intValue;
  }
  throw new Error("Could not parse number string.");
}
const ZeroOrGreaterMonetaryAmountInPoundsField = ({ valueInPence, onChangeInPence, ...delegateProps }) => {
  var _a;
  const penceToPounds = (0,currencies/* useConvertFromPenceFactory */.YQ)();
  const poundsToPence = (0,currencies/* useConvertFromPoundsFactory */.Pt)();
  return /* @__PURE__ */ react.createElement(TextField/* default */.Z, {
    type: "number",
    variant: "outlined",
    value: (_a = penceToPounds(valueInPence)) == null ? void 0 : _a.toString(),
    onChange: (e) => {
      let numberValue = 0;
      try {
        numberValue = parseNumber(e.target.value);
      } catch (_) {
        console.info(`Number not parseable, defaulting to ${numberValue}.`);
      }
      const value = Math.max(0, numberValue);
      const pence = Number(poundsToPence(value));
      onChangeInPence(pence);
    },
    ...delegateProps
  });
};
/* harmony default export */ const ZeroOrGreaterMonetaryAmountInPoundsField_ZeroOrGreaterMonetaryAmountInPoundsField = (ZeroOrGreaterMonetaryAmountInPoundsField);

;// CONCATENATED MODULE: ./src/client/price-list/components/ZeroOrGreaterMonetaryAmountInPoundsField/index.ts



;// CONCATENATED MODULE: ./src/client/price-list/components/RHF/RHFZeroOrGreaterMonetaryAmountInPoundsField.tsx



const RHFZeroOrGreaterMonetaryAmountInPoundsField = ({
  name,
  ...delegateProps
}) => {
  const {
    field: { value, onChange, onBlur, ref }
  } = (0,index_esm/* useController */.bc)({ name });
  return /* @__PURE__ */ react.createElement(ZeroOrGreaterMonetaryAmountInPoundsField_ZeroOrGreaterMonetaryAmountInPoundsField, {
    valueInPence: value,
    onChangeInPence: onChange,
    onBlur,
    name,
    inputRef: ref,
    ...delegateProps
  });
};
/* harmony default export */ const RHF_RHFZeroOrGreaterMonetaryAmountInPoundsField = (RHFZeroOrGreaterMonetaryAmountInPoundsField);

;// CONCATENATED MODULE: ./src/client/price-list/components/RHF/TextField.tsx



const TextField_TextField = (props) => {
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { error }
  } = (0,index_esm/* useController */.bc)({ name: props.name });
  const errorMessage = error == null ? void 0 : error.message;
  return /* @__PURE__ */ react.createElement(TextField/* default */.Z, {
    onChange,
    onBlur,
    inputRef: ref,
    error: !!error,
    helperText: errorMessage,
    value: value != null ? value : "",
    ...props
  });
};
/* harmony default export */ const RHF_TextField = (TextField_TextField);

;// CONCATENATED MODULE: ./src/client/price-list/components/RHF/index.ts



;// CONCATENATED MODULE: ./src/client/price-list/pages/PriceListPage/EditItemsTable.tsx














lib/* gql */.Ps`
  query revenueDepartments {
    priceListV2 {
      revenueDepartments {
        edges {
          id
          name
        }
      }
    }
  }
`;
const EditItemsTable = ({
  prices,
  handleDelete,
  handleRevert,
  ...delegateProps
}) => {
  var _a;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const currency = (0,currencies/* default */.ZP)();
  const { roleName } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const formattedCurrency = currency == null ? void 0 : currency.formatToParts(Number(currency))[0].value;
  const { data: revDepts, loading } = useRevenueDepartmentsQuery();
  const { setValue } = (0,index_esm/* useFormContext */.Gc)();
  const revenueDepartmentsOptions = (_a = revDepts == null ? void 0 : revDepts.priceListV2.revenueDepartments.edges.map((revDep) => ({
    value: revDep.id,
    label: revDep.name
  }))) != null ? _a : [];
  const columns = [
    {
      field: "name",
      flex: 4,
      headerName: formatMessage({
        id: "priceList.editItems.column.name",
        defaultMessage: "Item"
      }),
      renderCell: (value, _, __, row) => /* @__PURE__ */ react.createElement("p", {
        "aria-label": `${row.name} ${row.tariff.name}`
      }, value)
    },
    {
      field: "origin",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.editItems.column.origin",
        defaultMessage: "Item Type"
      }),
      renderCell: (value, _, __, row) => /* @__PURE__ */ react.createElement("p", {
        style: { textTransform: "capitalize" },
        "aria-label": `${row.name} ${row.tariff.name} item type`
      }, value.toLowerCase())
    },
    {
      field: "price",
      flex: 2,
      headerName: `${formatMessage({
        id: "priceList.editItems.column.price",
        defaultMessage: "Price"
      })} (${formattedCurrency})`,
      renderCell: (_, __, ___, row) => {
        const name = `${row.id}.price`;
        return /* @__PURE__ */ react.createElement(RHF_RHFZeroOrGreaterMonetaryAmountInPoundsField, {
          name,
          "data-testid": name,
          inputProps: {
            "aria-label": `${row.name} ${row.tariff.name} price`
          }
        });
      }
    },
    {
      field: "tariff",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.editItems.column.tariff",
        defaultMessage: "Price Type"
      }),
      renderCell: (value, _, __, row) => /* @__PURE__ */ react.createElement("p", {
        "aria-label": `${row.name} ${row.tariff.name} price type`
      }, value.name)
    },
    {
      field: "revenueDepartment",
      flex: 4,
      headerName: formatMessage({
        id: "priceList.editItems.column.revenueDepartment",
        defaultMessage: "Revenue Department"
      }),
      renderCell: (_, index, ___, row) => {
        return /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* SelectField */.mg, {
          name: `${row.id}.revenueDepartment.id`,
          options: revenueDepartmentsOptions,
          selectProps: {
            "data-testid": `revenueDepartments.select.${index}`,
            "aria-label": `${row.name} ${row.tariff.name} revenue department`
          },
          fullWidth: true,
          hideHelper: true
        });
      }
    },
    {
      field: "deleteRow",
      flex: 1,
      renderCell: (_, __, ___, row) => {
        var _a2;
        if (row.owner === base_gql/* ItemPriceOwner.Facility */._n.Facility && ((_a2 = row.parentPrice) == null ? void 0 : _a2.id)) {
          return /* @__PURE__ */ react.createElement(mui_button_dist_module/* IconButton */.hU, {
            onClick: () => {
              setValue(`${row.id}.active`, false, { shouldDirty: true });
              setValue(row.parentPrice.id, row.parentPrice);
              handleRevert(`${row.id}`, row.parentPrice);
            },
            color: "primary",
            "aria-label": formatMessage(
              {
                id: "priceList.editItems.column.revert",
                defaultMessage: "Revert {name} {tariff} price to organisation price"
              },
              { name: row.name, tariff: row.tariff.name }
            )
          }, /* @__PURE__ */ react.createElement(Undo/* default */.Z, null));
        }
        return /* @__PURE__ */ react.createElement(mui_button_dist_module/* IconButton */.hU, {
          onClick: () => {
            setValue(`${row.id}.active`, false, { shouldDirty: true });
            handleDelete(row.id);
          },
          disabled: roleName !== "admin" && row.owner === base_gql/* ItemPriceOwner.Organisation */._n.Organisation,
          color: "alert",
          "aria-label": formatMessage(
            {
              id: "priceList.editItems.column.delete",
              defaultMessage: "Delete {name} {tariff} price"
            },
            { name: row.name, tariff: row.tariff.name }
          )
        }, /* @__PURE__ */ react.createElement(Delete/* default */.Z, null));
      }
    }
  ];
  return /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    ...delegateProps,
    columns,
    rows: prices,
    loading
  });
};
/* harmony default export */ const PriceListPage_EditItemsTable = (EditItemsTable);

;// CONCATENATED MODULE: ./src/client/price-list/pages/PriceListPage/__generated__/EditItemsForm.gql.ts


const EditItemsForm_gql_defaultOptions = {};
const SetPricesDocument = lib/* gql */.Ps`
    mutation setPrices($input: SetPricesInput!) {
  priceListV2 {
    setPrices(input: $input) {
      processed
    }
  }
}
    `;
function useSetPricesMutation(baseOptions) {
  const options = { ...EditItemsForm_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(SetPricesDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/OverrideOrgPriceListModal.tsx






const OverrideOrgPriceListModal_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    alignItems: "center",
    display: "flex"
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  }
}));
const OverrideOrgPriceListModal = ({
  open,
  onClose,
  saveItems
}) => {
  const classes = OverrideOrgPriceListModal_useStyles();
  const handleSave = () => {
    saveItems();
    onClose();
  };
  return /* @__PURE__ */ react.createElement(mui_modal_dist_module/* Modal */.u_, {
    open
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement("img", {
    src: warningIcon_namespaceObject,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.overrideOrgPriceList.modal.title",
    defaultMessage: "Update Price List"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.overrideOrgPriceList.body",
    defaultMessage: "Some of the items you have edited are currently managed by your Org. Overwriting the prices for these items will prevent you from receiving future updates made by your organisation's administrator. Are you sure you want to proceed?"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => onClose()
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.overrideOrgPriceList.cancel",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    onClick: handleSave,
    "data-testid": "pricelist.modal.overrideOrgPriceList.accept"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.overrideOrgPriceList.confirm",
    defaultMessage: "Proceed"
  })))));
};
/* harmony default export */ const Modals_OverrideOrgPriceListModal = (OverrideOrgPriceListModal);

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(77589);
;// CONCATENATED MODULE: ./src/client/price-list/components/SubmitButton.tsx





const Spinner = (0,styled/* default */.Z)(CircularProgress/* default */.Z)({ padding: 4 });
const SubmitButton = ({ loading, ...delegateProps }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const onSubmitAndClickWhenLoading = (e) => {
    e.preventDefault();
    dist_default().info(
      formatMessage({
        id: "submitButton.onSubmit.alreadySubmitting",
        defaultMessage: "Submit already happening, please wait..."
      })
    );
  };
  return /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    ...delegateProps,
    onClick: loading ? onSubmitAndClickWhenLoading : delegateProps.onClick,
    onSubmit: loading ? onSubmitAndClickWhenLoading : delegateProps.onSubmit
  }, loading ? /* @__PURE__ */ react.createElement(Spinner, null) : delegateProps.children);
};
/* harmony default export */ const components_SubmitButton = (SubmitButton);

// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/index.ts
var components = __webpack_require__(19626);
;// CONCATENATED MODULE: ./src/client/price-list/pages/PriceListPage/EditItemsForm.tsx

















lib/* gql */.Ps`
  mutation setPrices($input: SetPricesInput!) {
    priceListV2 {
      setPrices(input: $input) {
        processed
      }
    }
  }
`;
const useFormSchema = () => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const editItemsSchema = () => (0,es.object)({
    price: (0,es.number)().typeError(
      formatMessage({
        id: "priceList.addItems.price.error",
        defaultMessage: "Please enter a price"
      })
    ),
    revenueDepartment: (0,es.object)({
      id: (0,es.string)().required(
        formatMessage({
          id: "priceList.addItems.revenueDepartmentId.required",
          defaultMessage: "Please enter the revenue department"
        })
      )
    })
  });
  return (0,es.lazy)((obj) => (0,es.object)(lodash_mapvalues_default()(obj, () => editItemsSchema())));
};
function mapPricesToDefaultValues(prices) {
  return prices.reduce(
    (prevVal, price) => ({
      ...prevVal,
      [`${price.id}`]: {
        ...price,
        active: true
      }
    }),
    {}
  );
}
const getSelectedValues = (obj, dirtyFields, priceableItems) => {
  var _a, _b;
  return (_b = (_a = priceableItems == null ? void 0 : priceableItems.filter((pi) => obj[pi.id])) == null ? void 0 : _a.filter((pi) => dirtyFields[pi.id])) == null ? void 0 : _b.map((pi) => ({
    active: obj[pi.id].active,
    itemId: pi.itemId,
    revenueDepartmentId: obj[pi.id].revenueDepartment.id,
    tariffId: obj[pi.id].tariff.id,
    value: obj[pi.id].price
  }));
};
const wereOrgValuesOverridden = (changedFields, prices) => {
  var _a;
  return ((_a = prices.filter(
    (p) => Object.keys(changedFields).includes(p.id) && p.owner === base_gql/* ItemPriceOwner.Organisation */._n.Organisation
  )) == null ? void 0 : _a.length) > 0;
};
const ButtonWrapper = (0,styled/* default */.Z)("div")(({ theme }) => ({
  pointerEvents: "none",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: theme.spacing(2),
  padding: theme.spacing(3, 7, 3, 0),
  position: "sticky",
  bottom: 0
}));
const EditItemsForm = ({
  priceListId,
  priceListOwner,
  priceableItems,
  setIsEditing,
  onEditCompleted,
  ...delegateProps
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const schema = useFormSchema();
  const [formPrices, setFormPrices] = (0,react.useState)(priceableItems);
  const [showOverrideOrgPriceModal, setShowOverrideOrgPriceModal] = (0,react.useState)(false);
  const [setPrices, { loading }] = useSetPricesMutation({
    onCompleted: () => {
      dist_default().success(
        formatMessage({
          id: "pricelist.editPrices.success",
          defaultMessage: "Successfully edited prices"
        })
      );
      setIsEditing(false);
      onEditCompleted == null ? void 0 : onEditCompleted();
    },
    onError: (e) => {
      dist_default().error(
        formatMessage(
          {
            id: "priceList.editPrices.error.msg",
            defaultMessage: "Failed to edit prices: {message}"
          },
          { message: e.message }
        )
      );
      setIsEditing(true);
    }
  });
  const editItemsMethods = (0,index_esm/* useForm */.cI)({
    mode: "all",
    reValidateMode: "onChange",
    resolver: (0,yup/* yupResolver */.X)(schema),
    defaultValues: mapPricesToDefaultValues(priceableItems)
  });
  const { isDirty, errors, isValid, dirtyFields } = editItemsMethods.formState;
  const handleSave = async (formValues) => {
    const didOrgValuesGotOverriden = wereOrgValuesOverridden(
      dirtyFields,
      formPrices
    );
    if ((0,isEmpty/* default */.Z)(errors)) {
      if (priceListOwner === base_gql/* ItemPriceOwner.Facility */._n.Facility && !showOverrideOrgPriceModal && didOrgValuesGotOverriden) {
        setShowOverrideOrgPriceModal(true);
      } else {
        setPrices({
          variables: {
            input: {
              priceListId,
              updates: getSelectedValues(
                formValues,
                dirtyFields,
                priceableItems
              )
            }
          }
        });
      }
    }
  };
  const handleDelete = async (id) => {
    const activePrices = formPrices.filter((p) => p.id !== id);
    setFormPrices(activePrices);
  };
  const handleRevert = (id, parentPrice) => {
    const index = formPrices.findIndex((p) => p.id === id);
    const newPrices = formPrices.map((p, idx) => {
      if (index === idx) {
        return parentPrice;
      }
      return p;
    });
    setFormPrices(newPrices);
  };
  return /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...editItemsMethods
  }, /* @__PURE__ */ react.createElement("form", {
    name: "editItemsForm",
    onSubmit: editItemsMethods.handleSubmit(handleSave)
  }, /* @__PURE__ */ react.createElement(PriceListPage_EditItemsTable, {
    ...delegateProps,
    prices: formPrices,
    handleDelete,
    handleRevert
  }), /* @__PURE__ */ react.createElement(ButtonWrapper, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    style: { pointerEvents: "auto" },
    color: "secondary",
    onClick: () => setIsEditing(false),
    "data-testid": "priceList.editItems.back.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.editItems.back.button",
    defaultMessage: "Back"
  })), /* @__PURE__ */ react.createElement(components_SubmitButton, {
    style: { pointerEvents: "auto" },
    color: "primary",
    type: "submit",
    "data-testid": "priceList.editItemsPage.save.button",
    disabled: !isDirty || !isValid,
    loading
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.editItemsPage.save.button",
    defaultMessage: "Save"
  }))), /* @__PURE__ */ react.createElement(components/* ConditionalDisplay */.fN, {
    condition: showOverrideOrgPriceModal
  }, /* @__PURE__ */ react.createElement(Modals_OverrideOrgPriceListModal, {
    open: showOverrideOrgPriceModal,
    onClose: () => setShowOverrideOrgPriceModal(false),
    saveItems: editItemsMethods.handleSubmit(handleSave)
  }))));
};
/* harmony default export */ const PriceListPage_EditItemsForm = (EditItemsForm);

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Edit.js
var Edit = __webpack_require__(36228);
;// CONCATENATED MODULE: ./src/client/price-list/pages/PriceListPage/PriceListTable.tsx







const PriceListTable_ButtonWrapper = (0,styled/* default */.Z)("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: theme.spacing(2),
  padding: theme.spacing(3, 7, 3, 0),
  position: "sticky",
  bottom: 0
}));
const PriceListTable = ({
  prices,
  setIsEditing,
  ...delegateProps
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const currency = (0,currencies/* default */.ZP)();
  const formattedCurrency = currency == null ? void 0 : currency.formatToParts(Number(currency))[0].value;
  const penceToPounds = (0,currencies/* useConvertFromPenceFactory */.YQ)();
  const columns = [
    {
      field: "name",
      flex: 5,
      headerName: formatMessage({
        id: "priceList.landingPage.column.name",
        defaultMessage: "Item"
      })
    },
    {
      field: "origin",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.landingPage.column.origin",
        defaultMessage: "Type"
      }),
      renderCell: (value) => /* @__PURE__ */ react.createElement("p", {
        style: { textTransform: "capitalize" }
      }, value.toLowerCase())
    },
    {
      field: "price",
      flex: 2,
      headerName: `${formatMessage({
        id: "priceList.landingPage.column.price",
        defaultMessage: "Price"
      })} (${formattedCurrency})`,
      renderCell: (value) => /* @__PURE__ */ react.createElement("p", null, penceToPounds(value))
    },
    {
      field: "tariff",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.landingPage.column.tariff",
        defaultMessage: "Price Type"
      }),
      renderCell: (value) => /* @__PURE__ */ react.createElement("p", null, value.name)
    },
    {
      field: "revenueDepartment",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.landingPage.column.revenueDepartment",
        defaultMessage: "Revenue Department"
      })
    },
    {
      field: "owner",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.landingPage.column.owner",
        defaultMessage: "Managed By"
      }),
      renderCell: (value) => /* @__PURE__ */ react.createElement("p", {
        style: { textTransform: "capitalize" }
      }, value.toLowerCase())
    }
  ];
  const rows = prices.map((price) => ({
    ...price,
    revenueDepartment: price.revenueDepartment.name
  }));
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    dataTestId: "priceList.table",
    columns,
    rows,
    ...delegateProps
  }), /* @__PURE__ */ react.createElement(PriceListTable_ButtonWrapper, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "primary",
    startIcon: /* @__PURE__ */ react.createElement(Edit/* default */.Z, null),
    onClick: () => setIsEditing(true),
    "data-testid": "priceList.edit.button",
    disabled: prices.length === 0
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.edit.button",
    defaultMessage: "Edit List"
  }))));
};
/* harmony default export */ const PriceListPage_PriceListTable = (PriceListTable);

;// CONCATENATED MODULE: ./src/client/price-list/pages/PriceListPage/FilterableEditablePriceListTable.tsx



function mapQueryToPrices(input) {
  var _a;
  return (_a = input == null ? void 0 : input.priceListV2.priceListItems.edges.flatMap(
    (row) => row.prices.map((price) => {
      var _a2, _b;
      return {
        id: price.id,
        itemId: row.id,
        name: row.name,
        origin: row.externalReference.origin,
        price: price.value,
        tariff: price.tariff,
        revenueDepartment: price.revenueDepartment,
        owner: price.owner,
        parentPrice: (price == null ? void 0 : price.parentPrice) ? {
          id: price.parentPrice.id,
          itemId: row.id,
          name: row.name,
          origin: row.externalReference.origin,
          price: price.parentPrice.value,
          tariff: price.parentPrice.tariff,
          revenueDepartment: (_a2 = price.parentPrice) == null ? void 0 : _a2.revenueDepartment,
          owner: (_b = price.parentPrice) == null ? void 0 : _b.owner
        } : null
      };
    })
  )) != null ? _a : [];
}
const FilterableEditablePriceListTable = ({
  data,
  ...delegateProps
}) => {
  const rows = mapQueryToPrices(data);
  const [isEditing, setIsEditing] = (0,react.useState)(false);
  const editRows = rows.map((price) => ({
    ...price,
    active: true,
    parentPrice: price.parentPrice ? {
      ...price.parentPrice,
      active: true
    } : void 0
  }));
  const {
    pagination,
    ...editItemsFormProps
  } = delegateProps;
  return isEditing ? /* @__PURE__ */ react.createElement(PriceListPage_EditItemsForm, {
    priceableItems: editRows,
    setIsEditing,
    ...editItemsFormProps
  }) : /* @__PURE__ */ react.createElement(PriceListPage_PriceListTable, {
    prices: rows,
    setIsEditing,
    ...delegateProps
  });
};
/* harmony default export */ const PriceListPage_FilterableEditablePriceListTable = (FilterableEditablePriceListTable);

;// CONCATENATED MODULE: ./src/client/price-list/pages/PriceListPage/images/emptyState.svg
const emptyState_namespaceObject = __webpack_require__.p + "assets/emptyState.svg";
;// CONCATENATED MODULE: ./src/client/price-list/pages/PriceListPage/EmptyPriceListState.tsx




const EmptyStateContainer = (0,styled/* default */.Z)(Grid/* default */.Z)(() => ({
  textAlign: "center"
}));
const EmptyStateImage = (0,styled/* default */.Z)("img")(() => ({
  margin: "20px auto",
  width: "100px"
}));
const EmptyPriceListState = () => {
  return /* @__PURE__ */ react.createElement(EmptyStateContainer, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, null, /* @__PURE__ */ react.createElement(EmptyStateImage, {
    src: emptyState_namespaceObject,
    alt: ""
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement("b", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.emptyPriceListState.title",
    defaultMessage: "Your price list contains no items yet"
  })))));
};
/* harmony default export */ const PriceListPage_EmptyPriceListState = (EmptyPriceListState);

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+role-definitions@3.0.0/node_modules/@elephant-healthcare/role-definitions/dist/module.js
var role_definitions_dist_module = __webpack_require__(4377);
// EXTERNAL MODULE: ./src/client/routes/links.ts
var routes_links = __webpack_require__(82303);
;// CONCATENATED MODULE: ./src/client/price-list/pages/PriceListPage/PriceListPage.tsx






















lib/* gql */.Ps`
  query getPriceList($input: PriceListItemsInput!, $options: PriceListItemsOptions) {
    priceListV2 {
      priceListItems(input: $input, options: $options) {
        pageInfo {
          pageNumber
          pageSize
          totalRows
        }
        edges {
          id
          name
          externalReference {
            origin
          }
          prices {
            id
            value
            owner
            tariff {
              id
              name
            }
            revenueDepartment {
              id
              name
            }
            owner
            parentPrice {
              id
              value
              owner
              tariff {
                id
                name
              }
              revenueDepartment {
                id
                name
              }
              owner
            }
          }
        }
        meta {
          linkedToOrganisation
          facilityId
        }
      }
    }
  }
`;
const ActionButtonsWrapper = (0,styled/* default */.Z)("div")({
  display: "flex",
  flexDirection: "row"
});
const ActionButtons = ({ priceListId, refetchPriceList, priceListOwner, isConnectedToOrg }) => {
  const [showAddItemsModal, setShowAddItemsModal] = (0,react.useState)(false);
  const [showConnectPriceListModal, setShowConnectPriceListModal] = (0,react.useState)(false);
  const [showDisconnectPriceListModal, setShowDisconnectPriceListModal] = (0,react.useState)(false);
  return /* @__PURE__ */ react.createElement(ActionButtonsWrapper, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "secondary",
    onClick: () => setShowAddItemsModal(true),
    startIcon: /* @__PURE__ */ react.createElement(Add/* default */.Z, null),
    "data-testid": "priceList.addItems.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.addItems.button",
    defaultMessage: "Add Items"
  })), /* @__PURE__ */ react.createElement(components/* ConditionalDisplay */.fN, {
    condition: priceListOwner === base_gql/* ItemPriceOwner.Facility */._n.Facility
  }, isConnectedToOrg ? /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => setShowDisconnectPriceListModal(true),
    startIcon: /* @__PURE__ */ react.createElement(LinkOff/* default */.Z, null),
    "data-testid": "priceList.disconnectFromOrgPriceList.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.disconnectFromOrgPriceList.button",
    defaultMessage: "Disconnect from Org Price List"
  })) : /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => setShowConnectPriceListModal(true),
    startIcon: /* @__PURE__ */ react.createElement(Link/* default */.Z, null),
    "data-testid": "priceList.connectToOrgPriceList.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.connectToPriceList.button",
    defaultMessage: "Connect to Org Price List"
  }))), /* @__PURE__ */ react.createElement(Modals_AddItemsModal, {
    open: showAddItemsModal,
    onClose: () => setShowAddItemsModal(false),
    priceListId
  }), /* @__PURE__ */ react.createElement(Modals_ConnectToOrgPriceListModal, {
    open: showConnectPriceListModal,
    onClose: () => setShowConnectPriceListModal(false),
    onCompleted: refetchPriceList,
    priceListId
  }), /* @__PURE__ */ react.createElement(Modals_DisconnectFromOrgPriceListModal, {
    priceListId,
    open: showDisconnectPriceListModal,
    onClose: () => setShowDisconnectPriceListModal(false),
    onCompleted: refetchPriceList
  }));
};
const PageContent = ({ priceListId, priceListOwner }) => {
  var _a, _b, _c, _d;
  const [pageNumber, setPageNumber] = (0,react.useState)(0);
  const [pageSize, setPageSize] = (0,react.useState)(20);
  const {
    data,
    loading,
    error,
    refetch: refetchPriceList
  } = useGetPriceListQuery({
    variables: {
      input: { priceListId },
      options: { pagination: { pageNumber, pageSize } }
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true
  });
  const isConnectedToOrg = (_c = (_b = (_a = data == null ? void 0 : data.priceListV2) == null ? void 0 : _a.priceListItems.meta) == null ? void 0 : _b.linkedToOrganisation) != null ? _c : false;
  if (error && !loading && !data) {
    return /* @__PURE__ */ react.createElement(dist/* Navigate */.Fg, {
      to: (0,routing_links/* linkToPriceListHome */.o0)()
    });
  }
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(ActionButtons, {
    priceListId,
    priceListOwner,
    isConnectedToOrg,
    refetchPriceList
  }), /* @__PURE__ */ react.createElement(PriceListPage_FilterableEditablePriceListTable, {
    priceListId,
    priceListOwner,
    data,
    loading,
    dense: true,
    onEditCompleted: refetchPriceList,
    noDataMessage: /* @__PURE__ */ react.createElement(PriceListPage_EmptyPriceListState, null),
    pagination: {
      page: pageNumber,
      handlePageChange: setPageNumber,
      pageSize,
      handlePageSizeChange: setPageSize,
      pageSizeOptions: [20, 50, 100],
      totalRows: (_d = data == null ? void 0 : data.priceListV2.priceListItems.pageInfo.totalRows) != null ? _d : 0
    }
  }));
};
const PriceListPage = () => {
  const { id: priceListId } = (0,dist/* useParams */.UO)();
  const user = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  if (!priceListId) {
    return /* @__PURE__ */ react.createElement(dist/* Navigate */.Fg, {
      to: (0,routing_links/* linkToPriceListHome */.o0)()
    });
  }
  const acceptableRoles = [role_definitions_dist_module/* Role.ADMIN */.uU.ADMIN, role_definitions_dist_module/* Role.CLINIC */.uU.CLINIC];
  if (!acceptableRoles.includes(user.roleName)) {
    return /* @__PURE__ */ react.createElement(dist/* Navigate */.Fg, {
      to: (0,routes_links/* linkToHome */.J4)()
    });
  }
  const priceListOwner = user.roleName === role_definitions_dist_module/* Role.CLINIC */.uU.CLINIC ? base_gql/* ItemPriceOwner.Facility */._n.Facility : base_gql/* ItemPriceOwner.Organisation */._n.Organisation;
  return /* @__PURE__ */ react.createElement(PageLayout_Page, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h2"
  }, priceListOwner === base_gql/* ItemPriceOwner.Organisation */._n.Organisation ? /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.header.organisation.title",
    defaultMessage: "Organisation Price List"
  }) : /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.header.facility.title",
    defaultMessage: "Facility Price List"
  })), /* @__PURE__ */ react.createElement(PageContent, {
    priceListId,
    priceListOwner
  }));
};
/* harmony default export */ const PriceListPage_PriceListPage = (PriceListPage);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var react_intl_lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./node_modules/.pnpm/use-debounce@8.0.4_react@18.1.0/node_modules/use-debounce/dist/index.module.js
var index_module = __webpack_require__(53890);
;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/__generated__/AddItemsPage.gql.ts


const AddItemsPage_gql_defaultOptions = {};
const UpsertPricesAndPriceableItemsDocument = lib/* gql */.Ps`
    mutation upsertPricesAndPriceableItems($input: UpsertPricesAndPriceableItemsInput!) {
  priceListV2 {
    upsertPricesAndPriceableItems(input: $input) {
      totalItemsUpserted
      totalPricesUpserted
    }
  }
}
    `;
function useUpsertPricesAndPriceableItemsMutation(baseOptions) {
  const options = { ...AddItemsPage_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(UpsertPricesAndPriceableItemsDocument, options);
}
const RevenueDepartmentsAndTariffsDocument = lib/* gql */.Ps`
    query revenueDepartmentsAndTariffs {
  priceListV2 {
    revenueDepartments {
      edges {
        id
        name
      }
    }
    priceTariffs {
      edges {
        id
        name
      }
    }
  }
}
    `;
function useRevenueDepartmentsAndTariffsQuery(baseOptions) {
  const options = { ...AddItemsPage_gql_defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(RevenueDepartmentsAndTariffsDocument, options);
}
function useRevenueDepartmentsAndTariffsLazyQuery(baseOptions) {
  const options = { ...AddItemsPage_gql_defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(RevenueDepartmentsAndTariffsDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/hooks/useQueryString.ts

function useQuerystring() {
  const { search } = (0,dist/* useLocation */.TH)();
  return Object.fromEntries(new URLSearchParams(search).entries());
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(91241);
// EXTERNAL MODULE: ./src/client/components/Inventory/SupplyLevelChip.tsx
var SupplyLevelChip = __webpack_require__(64518);
;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/ItemNameWithSupplyChip/ItemNameWithSupplyChip.tsx



const Wrapper = (0,styled/* default */.Z)("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "center",
  alignItems: "baseline",
  gap: theme.spacing(1)
}));
const Copy = (0,styled/* default */.Z)("p")({
  padding: 0,
  margin: 0
});
function ItemNameWithSupplyChip({ copy, data }) {
  return /* @__PURE__ */ react.createElement(Wrapper, {
    "data-testid": "stock-item"
  }, /* @__PURE__ */ react.createElement(Copy, {
    id: `item-name-${data.id}`,
    "data-testid": "stock-item-copy"
  }, copy), data.meta && /* @__PURE__ */ react.createElement(SupplyLevelChip/* default */.Z, {
    supplyLevel: data.meta.supplyLevel,
    quantity: data.meta.facilityQuantity,
    "data-testid": "stock-item-chip"
  }));
}

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/ItemNameWithSupplyChip/index.ts


;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/AddItemsTable.tsx










const AddItemsTable_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  selectFieldContainer: {
    display: "block",
    textAlign: "center"
  },
  error: {
    color: theme.palette.error.main,
    fontSize: "0.75rem"
  }
}));
const HideableTextField = ({ item }) => {
  const { watch } = (0,index_esm/* useFormContext */.Gc)();
  const rowFormData = watch(`${item.id}`);
  const name = `${item.id}.price`;
  return rowFormData ? /* @__PURE__ */ react.createElement(RHF_RHFZeroOrGreaterMonetaryAmountInPoundsField, {
    name,
    inputProps: { "aria-label": `${item.name} price` },
    "data-testid": name
  }) : null;
};
const HideableSelectField = ({ rowId, ...delegateProps }) => {
  var _a, _b;
  const {
    watch,
    formState: { errors }
  } = (0,index_esm/* useFormContext */.Gc)();
  const classes = AddItemsTable_useStyles();
  const rowFormData = watch(`${rowId}`);
  const errorMessage = (_b = (_a = errors == null ? void 0 : errors[rowId]) == null ? void 0 : _a.revenueDepartment) == null ? void 0 : _b.message;
  return rowFormData ? /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    className: classes.selectFieldContainer
  }, /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* SelectField */.mg, {
    ...delegateProps,
    error: errorMessage,
    helperText: errorMessage
  }), /* @__PURE__ */ react.createElement(components/* ConditionalDisplay */.fN, {
    condition: !!errorMessage
  }, /* @__PURE__ */ react.createElement("p", {
    className: classes.error
  }, errorMessage))) : null;
};
const FormDefaultInjectingCheckbox = ({ dataToInject, rowId }) => {
  const { getValues, setValue } = (0,index_esm/* useFormContext */.Gc)();
  const onChecked = () => {
    setValue(`${rowId}`, { ...dataToInject });
  };
  const onUnchecked = () => {
    setValue(`${rowId}`, null);
  };
  return /* @__PURE__ */ react.createElement(Checkbox/* default */.Z, {
    inputProps: { "aria-labelledby": `item-name-${rowId}` },
    checked: !!getValues()[rowId],
    onChange: (_, checked) => checked ? onChecked() : onUnchecked()
  });
};
const AddItemsTable = ({
  fixedRowData,
  revenueDepartments,
  ...delegateProps
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const currency = (0,currencies/* default */.ZP)();
  const formattedCurrency = currency == null ? void 0 : currency.formatToParts(Number(currency))[0].value;
  const revenueDepartmentsOptions = revenueDepartments.map((r) => ({
    value: r.id,
    label: r.name
  }));
  const columns = [
    {
      field: "id",
      flex: 1,
      renderCell: (_, __, ___, row) => {
        if (revenueDepartments.length === 0) {
          return /* @__PURE__ */ react.createElement(CircularProgress/* default */.Z, null);
        }
        return /* @__PURE__ */ react.createElement(FormDefaultInjectingCheckbox, {
          rowId: row.id,
          dataToInject: {
            name: row.name,
            tariffId: row.tariff.id,
            externalReference: {
              foreignId: `${row.id}`,
              origin: row.origin
            },
            price: 0,
            revenueDepartmentId: revenueDepartments[0].id
          }
        });
      }
    },
    {
      field: "name",
      flex: 4,
      headerName: formatMessage({
        id: "priceList.addItems.column.name",
        defaultMessage: "Item"
      }),
      renderCell: (value, _, __, row) => {
        return /* @__PURE__ */ react.createElement(ItemNameWithSupplyChip, {
          copy: value,
          data: row
        });
      }
    },
    {
      field: "origin",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.addItems.column.origin",
        defaultMessage: "Type"
      }),
      renderCell: (value) => /* @__PURE__ */ react.createElement("p", {
        style: { textTransform: "capitalize" }
      }, value.toLowerCase())
    },
    {
      field: "price",
      flex: 2,
      headerName: `${formatMessage({
        id: "priceList.addItems.column.price",
        defaultMessage: "Price"
      })} (${formattedCurrency})`,
      renderCell: (_, __, ___, row) => /* @__PURE__ */ react.createElement(HideableTextField, {
        item: row
      })
    },
    {
      field: "tariff",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.addItems.column.tariff",
        defaultMessage: "Price Type"
      }),
      renderCell: (data) => data.name
    },
    {
      field: "revenueDepartmentId",
      flex: 4,
      headerName: formatMessage({
        id: "priceList.addItems.column.revenueDepartment",
        defaultMessage: "Revenue Department"
      }),
      renderCell: (_, __, ___, row) => {
        if (revenueDepartments.length === 0) {
          return /* @__PURE__ */ react.createElement(CircularProgress/* default */.Z, null);
        }
        return /* @__PURE__ */ react.createElement(HideableSelectField, {
          name: `${row.id}.revenueDepartmentId`,
          rowId: row.id,
          hideHelper: true,
          options: revenueDepartmentsOptions,
          selectProps: { "aria-label": `${row.name} revenue department` }
        });
      }
    }
  ];
  return /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    columns,
    rows: fixedRowData,
    ...delegateProps
  });
};
/* harmony default export */ const AddItemsPage_AddItemsTable = (AddItemsTable);

;// CONCATENATED MODULE: ./src/client/price-list/predicates.ts
const isNotNullOrUndefined = (v) => {
  return !(v === null || v === void 0);
};

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/FinalisedItemsTable.tsx






const FinalisedItemsTable = ({
  revenueDepartments,
  tariffs
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { getValues } = (0,index_esm/* useFormContext */.Gc)();
  const currency = (0,currencies/* default */.ZP)();
  const formattedCurrency = currency == null ? void 0 : currency.formatToParts(Number(currency))[0].value;
  const penceToPounds = (0,currencies/* useConvertFromPenceFactory */.YQ)();
  const rows = Object.values(getValues()).filter(isNotNullOrUndefined).map((r) => ({
    ...r,
    id: r.externalReference.foreignId
  }));
  const columns = [
    {
      field: "name",
      flex: 4,
      headerName: formatMessage({
        id: "priceList.finalisedPage.column.name",
        defaultMessage: "Item"
      })
    },
    {
      field: "externalReference",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.finalisedPage.column.origin",
        defaultMessage: "Type"
      }),
      renderCell: (value) => /* @__PURE__ */ react.createElement("p", {
        style: { textTransform: "capitalize" }
      }, value.origin.toLowerCase())
    },
    {
      field: "price",
      flex: 2,
      headerName: `${formatMessage({
        id: "priceList.finalisedPage.column.price",
        defaultMessage: "Price"
      })} (${formattedCurrency})`,
      renderCell: (value) => /* @__PURE__ */ react.createElement("p", null, penceToPounds(value))
    },
    {
      field: "tariffId",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.finalisedPage.column.tariff",
        defaultMessage: "Price Type"
      }),
      renderCell: (value) => {
        var _a;
        const tariffName = tariffs ? (_a = tariffs.find((r) => r.id === value)) == null ? void 0 : _a.name : value;
        return /* @__PURE__ */ react.createElement("p", {
          style: { textTransform: "capitalize" }
        }, tariffName);
      }
    },
    {
      field: "revenueDepartmentId",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.finalisedPage.column.revenueDepartment",
        defaultMessage: "Revenue Department"
      }),
      renderCell: (value) => {
        var _a;
        const revenueDepartmentName = (_a = revenueDepartments == null ? void 0 : revenueDepartments.find(
          (r) => r.id === value
        )) == null ? void 0 : _a.name;
        return /* @__PURE__ */ react.createElement("p", {
          style: { textTransform: "capitalize" }
        }, revenueDepartmentName);
      }
    }
  ];
  return /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    columns,
    rows,
    dense: true
  });
};
/* harmony default export */ const AddItemsPage_FinalisedItemsTable = (FinalisedItemsTable);

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(90322);
;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/__generated__/useSearchNewInventoryLazyQuery.gql.ts


const useSearchNewInventoryLazyQuery_gql_defaultOptions = {};
const SearchInventoryItemsDocument = lib/* gql */.Ps`
    query searchInventoryItems($name: String, $pageSize: Int!, $pageNumber: Int!, $facilityId: String!, $orderBy: InventorySearchOrderProperty!) {
  inventorySearchTmp(input: {name: $name, facilityId: $facilityId}, options: {pageSize: $pageSize, pageNumber: $pageNumber, order: {by: $orderBy}}) {
    totalCount
    edges {
      node {
        sku {
          id
          name
        }
        supplyLevel
        facilityQuantity
      }
    }
  }
}
    `;
function useSearchInventoryItemsQuery(baseOptions) {
  const options = { ...useSearchNewInventoryLazyQuery_gql_defaultOptions, ...baseOptions };
  return Apollo.useQuery(SearchInventoryItemsDocument, options);
}
function useSearchInventoryItemsLazyQuery(baseOptions) {
  const options = { ...useSearchNewInventoryLazyQuery_gql_defaultOptions, ...baseOptions };
  return useLazyQuery/* useLazyQuery */.t(SearchInventoryItemsDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/useSearchNewInventoryLazyQuery.ts



lib/* gql */.Ps`
  query searchInventoryItems(
    $name: String
    $pageSize: Int!
    $pageNumber: Int!
    $facilityId: String!
    $orderBy: InventorySearchOrderProperty!
  ) {
    inventorySearchTmp(
      input: { name: $name, facilityId: $facilityId }
      options: { pageSize: $pageSize, pageNumber: $pageNumber, order: { by: $orderBy } }
    ) {
      totalCount
      edges {
        node {
          sku {
            id
            name
          }
          supplyLevel
          facilityQuantity
        }
      }
    }
  }
`;
function mapGqlResponseToResult({
  data,
  loading,
  error
}) {
  var _a, _b, _c;
  return {
    loading,
    error,
    data: {
      rows: (_b = (_a = data == null ? void 0 : data.inventorySearchTmp) == null ? void 0 : _a.edges.map(({ node }) => ({
        id: node.sku.id,
        name: node.sku.name,
        meta: node.supplyLevel ? {
          supplyLevel: node.supplyLevel,
          facilityQuantity: node.facilityQuantity || 0
        } : void 0,
        origin: base_gql/* PriceableItemOrigin.Inventory */.l1.Inventory
      }))) != null ? _b : [],
      totalRows: (_c = data == null ? void 0 : data.inventorySearchTmp.totalCount) != null ? _c : 0
    }
  };
}
const useSearchNewInventoryItemLazyQuery = () => {
  const [query, response] = useSearchInventoryItemsLazyQuery();
  const wrappedQuery = (args) => query({
    variables: {
      ...args.variables,
      orderBy: args.variables.name ? base_gql/* InventorySearchOrderProperty.NameRelavance */.II.NameRelavance : base_gql/* InventorySearchOrderProperty.Name */.II.Name
    }
  }).then(mapGqlResponseToResult);
  return [wrappedQuery, mapGqlResponseToResult(response)];
};
/* harmony default export */ const useSearchNewInventoryLazyQuery = (useSearchNewInventoryItemLazyQuery);

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/__generated__/useSearchInvestigationLazyQuery.gql.ts


const useSearchInvestigationLazyQuery_gql_defaultOptions = {};
const SearchInvestigationItemsDocument = lib/* gql */.Ps`
    query searchInvestigationItems {
  catalogueInvestigationActivities {
    _id
    title
  }
}
    `;
function useSearchInvestigationItemsQuery(baseOptions) {
  const options = { ...useSearchInvestigationLazyQuery_gql_defaultOptions, ...baseOptions };
  return Apollo.useQuery(SearchInvestigationItemsDocument, options);
}
function useSearchInvestigationItemsLazyQuery(baseOptions) {
  const options = { ...useSearchInvestigationLazyQuery_gql_defaultOptions, ...baseOptions };
  return useLazyQuery/* useLazyQuery */.t(SearchInvestigationItemsDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/helpers.ts
function sortByName(a, b) {
  if (!a || !b)
    return 0;
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  }
  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  }
  return 0;
}
function matchName(name, paramName, lang) {
  if (!name)
    return false;
  if (!paramName)
    return true;
  if (lang)
    return name.toLocaleLowerCase(lang).includes(paramName.toLocaleLowerCase(lang));
  return name.toLowerCase().includes(paramName.toLowerCase());
}
function paginate(rows, pageSize, pageNumber) {
  return rows.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
}
function sortFilterAndPaginate(rows, params, lang) {
  const { name: paramName, pageSize, pageNumber } = params.variables;
  return paginate(
    rows.filter((row) => row && matchName(row.name, paramName, lang)).sort(sortByName),
    pageSize,
    pageNumber
  );
}

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/useSearchInvestigationLazyQuery.ts





lib/* gql */.Ps`
  query searchInvestigationItems {
    catalogueInvestigationActivities {
      _id
      title
    }
  }
`;
const useSearchInvestigationLazyQuery_mapGqlResponseToResult = (response, params) => {
  var _a, _b;
  const investigations = (_b = (_a = response.data) == null ? void 0 : _a.catalogueInvestigationActivities.map(
    (investigation) => (investigation == null ? void 0 : investigation._id) && investigation.title ? {
      id: investigation._id,
      name: investigation.title,
      origin: base_gql/* PriceableItemOrigin.Investigation */.l1.Investigation
    } : null
  ).filter(Boolean)) != null ? _b : [];
  const rows = sortFilterAndPaginate(investigations, params);
  const data = {
    rows: rows != null ? rows : [],
    totalRows: rows == null ? void 0 : rows.length
  };
  return {
    ...response,
    data
  };
};
const useSearchInvestigationItemLazyQuery = () => {
  const [data, setData] = (0,react.useState)({
    data: {
      rows: [],
      totalRows: 0
    },
    loading: false
  });
  const [query] = useSearchInvestigationItemsLazyQuery();
  const wrappedQuery = (0,react.useMemo)(
    () => (args) => query().then((res) => {
      const newData = useSearchInvestigationLazyQuery_mapGqlResponseToResult(res, args);
      setData(newData);
      return newData;
    }),
    []
  );
  return [wrappedQuery, data];
};
/* harmony default export */ const useSearchInvestigationLazyQuery = (useSearchInvestigationItemLazyQuery);

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/useSearchGeneralItemResult.ts


var GENERAL = /* @__PURE__ */ ((GENERAL2) => {
  GENERAL2["CONSULTATION"] = "Consultation";
  GENERAL2["ELEPHANT_REGISTRATION"] = "Elephant Registration";
  GENERAL2["INPATIENT_ADMISSION"] = "Inpatient Admission";
  return GENERAL2;
})(GENERAL || {});
const generalItems = [
  {
    id: "7d2f0794-807a-4a3e-bc50-9a98c60a8bf0",
    name: "Consultation" /* CONSULTATION */,
    origin: base_gql/* PriceableItemOrigin.General */.l1.General
  },
  {
    id: "18c0c6a3-f4bc-4bfe-8d40-2865980dcaed",
    name: "Elephant Registration" /* ELEPHANT_REGISTRATION */,
    origin: base_gql/* PriceableItemOrigin.General */.l1.General
  },
  {
    id: "e03f2196-157d-4b64-ad52-fa6b7cf37110s",
    name: "Inpatient Admission" /* INPATIENT_ADMISSION */,
    origin: base_gql/* PriceableItemOrigin.General */.l1.General
  }
];
const mapResponseToResult = (params) => {
  var _a;
  const items = ((_a = params == null ? void 0 : params.variables) == null ? void 0 : _a.name) ? sortFilterAndPaginate(generalItems, params) : generalItems;
  const data = {
    rows: items,
    totalRows: items.length
  };
  return { data, loading: false, error: void 0 };
};
const useSearchGeneralItemResult = [
  async (args) => mapResponseToResult(args),
  mapResponseToResult()
];
/* harmony default export */ const useSearchNewItemLazyQuery_useSearchGeneralItemResult = (useSearchGeneralItemResult);

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/__generated__/useSearchProcedureLazyQuery.gql.ts


const useSearchProcedureLazyQuery_gql_defaultOptions = {};
const ActiveDiseasesDocument = lib/* gql */.Ps`
    query ActiveDiseases {
  diseases {
    id
    items {
      uuid
      category
      code
      coding
      categoryDisplayName
      displayName
      keywords
    }
    categoryItems {
      displayName
      value
    }
  }
}
    `;
function useActiveDiseasesQuery(baseOptions) {
  const options = { ...useSearchProcedureLazyQuery_gql_defaultOptions, ...baseOptions };
  return Apollo.useQuery(ActiveDiseasesDocument, options);
}
function useActiveDiseasesLazyQuery(baseOptions) {
  const options = { ...useSearchProcedureLazyQuery_gql_defaultOptions, ...baseOptions };
  return useLazyQuery/* useLazyQuery */.t(ActiveDiseasesDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/useSearchProcedureLazyQuery.ts





lib/* gql */.Ps`
  query ActiveDiseases {
    diseases {
      id
      items {
        uuid
        category
        code
        coding
        categoryDisplayName
        displayName
        keywords
      }
      categoryItems {
        displayName
        value
      }
    }
  }
`;
const PROCEDURE_PREFIX_LEN = "Procedure: ".length;
const IS_DISEASE_PROCEDURE_REGEX = /^\$P\d+/;
function isDefined(foo) {
  return foo !== void 0 && foo !== null;
}
function useSearchProcedureLazyQuery_mapGqlResponseToResult({ data, loading, error }, params) {
  var _a, _b, _c, _d;
  const procedures = (_d = (_c = (_b = (_a = data == null ? void 0 : data.diseases) == null ? void 0 : _a.items) == null ? void 0 : _b.filter(isDefined)) == null ? void 0 : _c.filter((e) => {
    var _a2;
    return IS_DISEASE_PROCEDURE_REGEX.test((_a2 = e == null ? void 0 : e.code) != null ? _a2 : "");
  }).map((d) => ({
    id: d.uuid,
    name: d == null ? void 0 : d.displayName.substring(PROCEDURE_PREFIX_LEN),
    origin: base_gql/* PriceableItemOrigin.Procedure */.l1.Procedure
  }))) != null ? _d : [];
  const rows = sortFilterAndPaginate(procedures, params);
  return {
    loading,
    error,
    data: {
      rows,
      totalRows: rows.length
    }
  };
}
const useSearchProcedureItemLazyQuery = () => {
  const [data, setData] = (0,react.useState)({
    loading: false,
    data: { rows: [], totalRows: 0 }
  });
  const [query] = useActiveDiseasesLazyQuery();
  const wrappedQuery = (0,react.useMemo)(
    () => (args) => query().then((res) => {
      const newData = useSearchProcedureLazyQuery_mapGqlResponseToResult(res, args);
      setData(newData);
      return newData;
    }),
    []
  );
  return [wrappedQuery, data];
};
/* harmony default export */ const useSearchProcedureLazyQuery = (useSearchProcedureItemLazyQuery);

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/__generated__/useSearchCustomItemLazyQuery.gql.ts


const useSearchCustomItemLazyQuery_gql_defaultOptions = {};
const GetCustomItemsDocument = lib/* gql */.Ps`
    query getCustomItems($priceListId: ID!) {
  priceListV2 {
    customItems(input: {priceListId: $priceListId}) {
      items {
        id
        name
      }
    }
  }
}
    `;
function useGetCustomItemsQuery(baseOptions) {
  const options = { ...useSearchCustomItemLazyQuery_gql_defaultOptions, ...baseOptions };
  return Apollo.useQuery(GetCustomItemsDocument, options);
}
function useGetCustomItemsLazyQuery(baseOptions) {
  const options = { ...useSearchCustomItemLazyQuery_gql_defaultOptions, ...baseOptions };
  return useLazyQuery/* useLazyQuery */.t(GetCustomItemsDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/useSearchCustomItemLazyQuery.ts






lib/* gql */.Ps`
  query getCustomItems($priceListId: ID!) {
    priceListV2 {
      customItems(input: { priceListId: $priceListId }) {
        items {
          id
          name
        }
      }
    }
  }
`;
const useSearchCustomItemLazyQuery_mapGqlResponseToResult = (response, params) => {
  var _a, _b;
  const customItems = (_b = (_a = response.data) == null ? void 0 : _a.priceListV2.customItems.items.map((item) => ({
    id: item.id,
    name: item.name,
    origin: base_gql/* PriceableItemOrigin.Custom */.l1.Custom
  }))) != null ? _b : [];
  const rows = sortFilterAndPaginate(customItems, params);
  const data = {
    rows: rows != null ? rows : [],
    totalRows: rows == null ? void 0 : rows.length
  };
  return {
    ...response,
    data
  };
};
const useSearchCustomItemLazyQuery = () => {
  const { id: priceListId } = (0,dist/* useParams */.UO)();
  const [data, setData] = (0,react.useState)({
    loading: false,
    data: { rows: [], totalRows: 0 }
  });
  const [query] = useGetCustomItemsLazyQuery({
    variables: { priceListId },
    fetchPolicy: "network-only"
  });
  const wrappedQuery = (0,react.useMemo)(
    () => (args) => query().then((res) => {
      const newData = useSearchCustomItemLazyQuery_mapGqlResponseToResult(res, args);
      setData(newData);
      return newData;
    }),
    []
  );
  return [wrappedQuery, data];
};
/* harmony default export */ const useSearchNewItemLazyQuery_useSearchCustomItemLazyQuery = (useSearchCustomItemLazyQuery);

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useSearchNewItemLazyQuery/index.ts






function useSearchNewItemLazyQuery(origin) {
  const inventoryHookResult = useSearchNewInventoryLazyQuery();
  const investigationHookResult = useSearchInvestigationLazyQuery();
  const procedureHookResult = useSearchProcedureLazyQuery();
  const customHookResult = useSearchNewItemLazyQuery_useSearchCustomItemLazyQuery();
  return {
    [base_gql/* PriceableItemOrigin.Custom */.l1.Custom]: customHookResult,
    [base_gql/* PriceableItemOrigin.General */.l1.General]: useSearchNewItemLazyQuery_useSearchGeneralItemResult,
    [base_gql/* PriceableItemOrigin.Inventory */.l1.Inventory]: inventoryHookResult,
    [base_gql/* PriceableItemOrigin.Investigation */.l1.Investigation]: investigationHookResult,
    [base_gql/* PriceableItemOrigin.Procedure */.l1.Procedure]: procedureHookResult
  }[origin];
}

// EXTERNAL MODULE: ./src/client/components/SearchBar/index.ts + 1 modules
var SearchBar = __webpack_require__(67753);
;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/CreateCustomItemsModal.tsx









lib/* gql */.Ps`
  mutation createCustomItems($input: createCustomItemsInput!) {
    priceListV2 {
      createCustomItems(input: $input) {
        items {
          id
          name
        }
      }
    }
  }
`;
const CreateCustomItemsModal_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  modal: {
    borderRadius: theme.spacing(3)
  },
  header: {
    backgroundColor: theme.palette.common.white,
    alignItems: "center",
    display: "flex"
  },
  warningIcon: {
    marginRight: theme.spacing(2)
  },
  itemName: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  }
}));
const CreateCustomItemsModal = ({
  open,
  onClose,
  priceListId
}) => {
  const classes = CreateCustomItemsModal_useStyles();
  const navigate = (0,dist/* useNavigate */.s0)();
  const confirm = () => {
    navigate((0,routing_links/* linkToCreateCustomItems */.M6)(priceListId));
    onClose();
  };
  return /* @__PURE__ */ react.createElement(mui_modal_dist_module/* Modal */.u_, {
    open
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    className: classes.header
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement("img", {
    src: warningIcon_namespaceObject,
    alt: "warning",
    className: classes.warningIcon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.createCustomItems.modal.title",
    defaultMessage: "Create Custom Item"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.createCustomItems.description",
    defaultMessage: "Custom Items will not automatically appear when creating the invoices since they will not be connected to clinical items.  If you want this item to automatically appear on your invoice please contact Elephant Helpdesk to add it."
  }))))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => onClose()
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.createCustomItems.cancel",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    onClick: confirm,
    "data-testid": "pricelist.modal.createCustomItems.accept"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.createCustomItems.confirm",
    defaultMessage: "Create Custom Item"
  })))));
};
/* harmony default export */ const Modals_CreateCustomItemsModal = (CreateCustomItemsModal);

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/useFormSchema.tsx




const useFormSchema_useFormSchema = () => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const priceSchema = (0,es.object)({
    price: (0,es.number)().required(
      formatMessage({
        id: "priceList.addItems.price.required",
        defaultMessage: "Please enter a price"
      })
    ).typeError(
      formatMessage({
        id: "priceList.addItems.price.typeError",
        defaultMessage: "Please enter a valid number"
      })
    ).test(
      "greater than 0",
      formatMessage({
        id: "priceList.addItems.price.positive",
        defaultMessage: "Please enter a positive number"
      }),
      (v) => (v != null ? v : 0) >= 0
    ),
    revenueDepartmentId: (0,es.string)().required(
      formatMessage({
        id: "priceList.addItems.revenueDepartment.required",
        defaultMessage: "Please enter the revenue department"
      })
    ),
    tariffId: (0,es.string)().required(),
    name: (0,es.string)().required(),
    externalReference: (0,es.object)({
      foreignId: (0,es.string)().required(),
      origin: (0,es.mixed)().required().test(
        (v) => Object.values(base_gql/* PriceableItemOrigin */.l1).includes(v)
      )
    })
  }).nullable();
  return (0,es.lazy)((obj) => (0,es.object)(lodash_mapvalues_default()(obj, () => priceSchema)));
};

;// CONCATENATED MODULE: ./src/client/price-list/pages/AddItemsPage/AddItemsPage.tsx

























lib/* gql */.Ps`
  mutation upsertPricesAndPriceableItems($input: UpsertPricesAndPriceableItemsInput!) {
    priceListV2 {
      upsertPricesAndPriceableItems(input: $input) {
        totalItemsUpserted
        totalPricesUpserted
      }
    }
  }
`;
lib/* gql */.Ps`
  query revenueDepartmentsAndTariffs {
    priceListV2 {
      revenueDepartments {
        edges {
          id
          name
        }
      }
      priceTariffs {
        edges {
          id
          name
        }
      }
    }
  }
`;
const ERROR_MESSAGE = (0,react_intl_lib/* defineMessage */.Em)({
  id: "priceList.addPrices.error.msg",
  defaultMessage: "Failed to add prices"
});
const AddItemsPage_useStyles = (0,makeStyles/* default */.Z)(() => ({
  customItemButton: {
    flexShrink: 0
  }
}));
const Header = (0,styled/* default */.Z)(Typography/* default */.Z)({});
const ButtonsAndFilters = (0,styled/* default */.Z)("div")({
  display: "flex",
  flexWrap: "nowrap",
  flexDirection: "row",
  alignItems: "center"
});
const AddItemsPage_SearchBar = (0,styled/* default */.Z)(SearchBar/* default */.Z)({});
const ContentWrapper = (0,styled/* default */.Z)("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3)
}));
const AddItemsPage_ButtonWrapper = (0,styled/* default */.Z)("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: theme.spacing(2),
  paddingRight: theme.spacing(8),
  position: "sticky",
  bottom: 0
}));
const AddItemsPage = () => {
  var _a, _b;
  const classes = AddItemsPage_useStyles();
  const { origin, tariffId } = useQuerystring();
  const navigate = (0,dist/* useNavigate */.s0)();
  const { facilityId } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const { id: priceListId } = (0,dist/* useParams */.UO)();
  const formSchema = useFormSchema_useFormSchema();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { data: revDeptsAndTariffs, loading: revDeptsAndTariffsLoading } = useRevenueDepartmentsAndTariffsQuery();
  const revenueDepartments = (_a = revDeptsAndTariffs == null ? void 0 : revDeptsAndTariffs.priceListV2.revenueDepartments.edges) != null ? _a : [];
  const tariffs = (_b = revDeptsAndTariffs == null ? void 0 : revDeptsAndTariffs.priceListV2.priceTariffs.edges) != null ? _b : [];
  const [
    _searchItems,
    { data: searchResults, loading: searchLoading, error: searchError }
  ] = useSearchNewItemLazyQuery(origin);
  const [searchTerm, setSearchTerm] = (0,react.useState)("");
  const [pageNumber, setPageNumber] = (0,react.useState)(0);
  const [pageSize, setPageSize] = (0,react.useState)(20);
  const [creatingCustomItems, setCreatingCustomItems] = (0,react.useState)(false);
  const [isEditable, setIsEditable] = (0,react.useState)(true);
  const [addPrices, { loading: addPricesLoading }] = useUpsertPricesAndPriceableItemsMutation({
    onCompleted: (data) => {
      dist_default().success(
        formatMessage(
          {
            id: "pricelist.addPrices.success",
            defaultMessage: "{totalPrices} {totalPrices, plural, one{price} other{prices}} added for {totalItems} {totalItems, plural, one{item} other{items}}"
          },
          {
            totalItems: data.priceListV2.upsertPricesAndPriceableItems.totalItemsUpserted,
            totalPrices: data.priceListV2.upsertPricesAndPriceableItems.totalPricesUpserted
          }
        )
      );
      navigate(`${(0,routing_links/* linkToPriceListHome */.o0)()}/${priceListId}`);
    },
    onError: (e) => {
      dist_default().error(`${formatMessage(ERROR_MESSAGE)}: ${e.message}`);
      setIsEditable(true);
    }
  });
  const tariff = (0,react.useMemo)(() => {
    if (revDeptsAndTariffsLoading) {
      return void 0;
    }
    const result = tariffs.find((r) => r.id === tariffId);
    if (!result) {
      dist_default().error(`No tariff with that id could be found: ${tariffId}`);
      navigate((0,routing_links/* linkToPriceListHome */.o0)());
      return void 0;
    }
    return result;
  }, [tariffId, revDeptsAndTariffsLoading, revDeptsAndTariffs]);
  const fixedRowData = (0,react.useMemo)(() => {
    return searchResults.rows.map((r) => ({
      ...r,
      tariff: tariff != null ? tariff : { id: "", name: "" }
    }));
  }, [searchResults, tariff]);
  const searchItems = (0,index_module/* useDebouncedCallback */.y1)(
    () => _searchItems({
      variables: {
        name: searchTerm,
        pageSize,
        pageNumber,
        facilityId
      }
    }),
    200
  );
  (0,react.useEffect)(() => {
    searchItems();
  }, [searchTerm, pageNumber, pageSize]);
  (0,react.useEffect)(() => {
    if (searchError) {
      dist_default().error(searchError.message);
    }
  }, [searchError]);
  const addItemsFormMethods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    resolver: (0,yup/* yupResolver */.X)(formSchema)
  });
  (0,react.useEffect)(() => {
    if (!priceListId) {
      dist_default().error("Price list to add items to has not been specified.");
      navigate((0,routing_links/* linkToPriceListHome */.o0)());
    }
  }, [priceListId]);
  if (!priceListId) {
    return null;
  }
  const onSubmit = (data) => {
    const priceableItems = Object.values(data).filter(isNotNullOrUndefined).map(
      ({
        name,
        externalReference,
        revenueDepartmentId,
        tariffId: rowTariffId,
        price
      }) => ({
        name,
        externalReference,
        prices: [
          { revenueDepartmentId, tariffId: rowTariffId, value: price }
        ]
      })
    );
    addPrices({
      variables: {
        input: {
          priceListId,
          priceableItems,
          language: base_gql/* PriceableItemLanguage.EnGb */.kA.EnGb
        }
      }
    });
  };
  return /* @__PURE__ */ react.createElement(PageLayout_Page, null, /* @__PURE__ */ react.createElement(Header, {
    variant: "h2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.addItems.header.title",
    defaultMessage: "Elephant Items List"
  })), /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...addItemsFormMethods
  }, /* @__PURE__ */ react.createElement("form", {
    onSubmit: addItemsFormMethods.handleSubmit(onSubmit)
  }, isEditable && /* @__PURE__ */ react.createElement(ContentWrapper, null, /* @__PURE__ */ react.createElement(ButtonsAndFilters, null, origin === base_gql/* PriceableItemOrigin.Custom */.l1.Custom && /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    className: classes.customItemButton,
    color: "tertiary",
    onClick: () => setCreatingCustomItems(true),
    startIcon: /* @__PURE__ */ react.createElement(Add/* default */.Z, null),
    "data-testid": "priceList.createCustomItem.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.createCustomItem.button",
    defaultMessage: "Create Custom Item"
  })), /* @__PURE__ */ react.createElement(AddItemsPage_SearchBar, {
    value: searchTerm,
    onChange: setSearchTerm,
    onClear: () => {
      setSearchTerm("");
    },
    placeholderText: formatMessage({
      id: "priceList.addPrices.search",
      defaultMessage: "Search items"
    })
  })), /* @__PURE__ */ react.createElement(AddItemsPage_AddItemsTable, {
    fixedRowData,
    revenueDepartments,
    pagination: {
      page: pageNumber,
      pageSize,
      totalRows: searchResults.totalRows,
      handlePageChange: (number) => setPageNumber(number),
      pageSizeOptions: [20, 50, 100],
      handlePageSizeChange: setPageSize
    },
    loading: searchLoading,
    dense: true
  }), /* @__PURE__ */ react.createElement(AddItemsPage_ButtonWrapper, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "secondary",
    onClick: () => navigate((0,routing_links/* linkToPriceList */.EF)(priceListId)),
    "data-testid": "priceList.addItemsPage.backToLandingPage.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.addItemsPage.backToLandingPage.button",
    defaultMessage: "Back"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "primary",
    onClick: () => {
      setIsEditable(false);
    },
    "data-testid": "priceList.addItemsPage.review.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.addItemsPage.review.button",
    defaultMessage: "Review"
  })))), !isEditable && /* @__PURE__ */ react.createElement(ContentWrapper, null, /* @__PURE__ */ react.createElement(AddItemsPage_FinalisedItemsTable, {
    revenueDepartments,
    tariffs
  }), /* @__PURE__ */ react.createElement(AddItemsPage_ButtonWrapper, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "secondary",
    onClick: () => setIsEditable(true),
    "data-testid": "priceList.addItemsPage.back.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.addItemsPage.back.button",
    defaultMessage: "Back"
  })), /* @__PURE__ */ react.createElement(components_SubmitButton, {
    color: "primary",
    type: "submit",
    "data-testid": "priceList.addItemsPage.finalise.button",
    loading: addPricesLoading
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.addItemsPage.finalise.button",
    defaultMessage: "Finalise"
  })))))), /* @__PURE__ */ react.createElement(Modals_CreateCustomItemsModal, {
    open: creatingCustomItems,
    onClose: () => setCreatingCustomItems(false),
    priceListId
  }));
};
/* harmony default export */ const AddItemsPage_AddItemsPage = (AddItemsPage);

// EXTERNAL MODULE: ./src/client/utils/randomId.ts
var randomId = __webpack_require__(73955);
;// CONCATENATED MODULE: ./src/client/price-list/pages/CreateCustomItemsPage/AppendableCreateCustomItemsTable.tsx










const ItemsTable = ({
  customItems,
  handleDelete,
  fieldArrayName,
  ...delegateProps
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const columns = [
    {
      field: "name",
      flex: 6,
      headerName: formatMessage({
        id: "priceList.createCustomItems.column.name",
        defaultMessage: "Item"
      }),
      renderCell: (_, index) => {
        const name = `${fieldArrayName}.${index}.name`;
        return /* @__PURE__ */ react.createElement(RHF_TextField, {
          label: "Name",
          name,
          inputProps: { "data-testid": name },
          fullWidth: true
        });
      }
    },
    {
      field: "origin",
      flex: 2,
      headerName: formatMessage({
        id: "priceList.createCustomItems.column.origin",
        defaultMessage: "Type"
      }),
      renderCell: () => /* @__PURE__ */ react.createElement(message/* default */.Z, {
        id: "priceList.createCustomItems.origin",
        defaultMessage: "Custom"
      })
    },
    {
      field: "deleteRow",
      flex: 1,
      renderCell: (_, index) => /* @__PURE__ */ react.createElement(mui_button_dist_module/* IconButton */.hU, {
        onClick: () => handleDelete(index),
        color: "alert",
        "aria-label": formatMessage({
          id: "priceList.createCustomItems.column.delete",
          defaultMessage: "Delete Item"
        })
      }, /* @__PURE__ */ react.createElement(Delete/* default */.Z, null))
    }
  ];
  return /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    columns,
    rows: customItems,
    ...delegateProps
  });
};
const AppendableCreateCustomItemsTable_Wrapper = (0,styled/* default */.Z)("div")({});
const AppendableCreateCustomItemsTable = ({
  ...delegateProps
}) => {
  const name = "items";
  const { fields, remove, append } = (0,index_esm/* useFieldArray */.Dq)({ name });
  return /* @__PURE__ */ react.createElement(AppendableCreateCustomItemsTable_Wrapper, null, /* @__PURE__ */ react.createElement(ItemsTable, {
    fieldArrayName: name,
    customItems: fields,
    handleDelete: remove,
    ...delegateProps
  }), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    startIcon: /* @__PURE__ */ react.createElement(Add/* default */.Z, null),
    onClick: () => append({ id: (0,randomId/* randomId */.k)() }),
    "data-testid": "priceList.createCustomItemsPage.addRow.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.createCustomItemsPage.addRow.button",
    defaultMessage: "Add Custom Item"
  })));
};
/* harmony default export */ const CreateCustomItemsPage_AppendableCreateCustomItemsTable = (AppendableCreateCustomItemsTable);

;// CONCATENATED MODULE: ./src/client/price-list/pages/CreateCustomItemsPage/__generated__/CreateCustomItemsForm.gql.ts


const CreateCustomItemsForm_gql_defaultOptions = {};
const CreateCustomItemsDocument = lib/* gql */.Ps`
    mutation createCustomItems($input: CreateCustomItemsInput!) {
  priceListV2 {
    createCustomItems(input: $input) {
      items {
        id
        name
      }
    }
  }
}
    `;
function useCreateCustomItemsMutation(baseOptions) {
  const options = { ...CreateCustomItemsForm_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(CreateCustomItemsDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/pages/CreateCustomItemsPage/useFormSchema.tsx


const CreateCustomItemsPage_useFormSchema_useFormSchema = () => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return (0,es.lazy)(
    (formValues) => (0,es.object)({
      items: (0,es.array)(
        (0,es.object)({
          id: (0,es.string)(),
          name: (0,es.string)().required(
            formatMessage({
              id: "priceList.createCustomItems.name.required",
              defaultMessage: "Please enter a name"
            })
          ).test({
            name: "Unique",
            message: formatMessage({
              id: "priceList.createCustomItems.name.unique",
              defaultMessage: "Item names must be unique"
            }),
            test: (thisName, ctx) => {
              return !formValues.items.some(
                (item) => item.name === thisName && item.id !== ctx.parent.id
              );
            }
          })
        })
      ).compact((item) => !item.name).default([])
    })
  );
};

;// CONCATENATED MODULE: ./src/client/price-list/pages/CreateCustomItemsPage/CreateCustomItemsForm.tsx













lib/* gql */.Ps`
  mutation createCustomItems($input: CreateCustomItemsInput!) {
    priceListV2 {
      createCustomItems(input: $input) {
        items {
          id
          name
        }
      }
    }
  }
`;
const ButtonsContainer = (0,styled/* default */.Z)("div")(({ theme }) => ({
  alignSelf: "flex-end",
  display: "flex",
  justifyContent: "flex-end",
  gap: theme.spacing(3)
}));
const CreateCustomItemsForm = ({
  priceListId
}) => {
  const navigate = (0,dist/* useNavigate */.s0)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const formSchema = CreateCustomItemsPage_useFormSchema_useFormSchema();
  const [addCustomItems] = useCreateCustomItemsMutation({
    onCompleted: (data) => {
      dist_default().success(
        formatMessage(
          {
            id: "pricelist.createCustomItems.success",
            defaultMessage: "Successfully created {quantity, number} custom items"
          },
          {
            quantity: data.priceListV2.createCustomItems.items.length
          }
        )
      );
      navigate(-1);
    },
    onError: (error) => {
      dist_default().error(
        formatMessage(
          {
            id: "priceList.createCustomItems.error.msg",
            defaultMessage: "Failed to create custom items: {message}"
          },
          {
            message: error.message
          }
        )
      );
    }
  });
  const createCustomItemsFormMethods = (0,index_esm/* useForm */.cI)({
    mode: "all",
    reValidateMode: "onChange",
    resolver: (0,yup/* yupResolver */.X)(formSchema),
    defaultValues: {
      items: [{ id: (0,randomId/* randomId */.k)() }]
    }
  });
  const handleSubmit = (data) => addCustomItems({
    variables: {
      input: { names: data.items.map((item) => item.name), priceListId }
    }
  });
  return /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...createCustomItemsFormMethods
  }, /* @__PURE__ */ react.createElement("form", {
    onSubmit: createCustomItemsFormMethods.handleSubmit(handleSubmit)
  }, /* @__PURE__ */ react.createElement(CreateCustomItemsPage_AppendableCreateCustomItemsTable, {
    dense: true
  }), /* @__PURE__ */ react.createElement(ButtonsContainer, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "secondary",
    onClick: () => navigate(-1),
    "data-testid": "priceList.createCustomItemsPage.back.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.createCustomItemsPage.back.button",
    defaultMessage: "Back"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    type: "submit",
    color: "primary",
    "data-testid": "priceList.createCustomItemsPage.save.button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "priceList.createCustomItemsPage.save.button",
    defaultMessage: "Save"
  })))));
};
/* harmony default export */ const CreateCustomItemsPage_CreateCustomItemsForm = (CreateCustomItemsForm);

;// CONCATENATED MODULE: ./src/client/price-list/pages/CreateCustomItemsPage/CreateCustomItemsPage.tsx







const CreateCustomItemsPage = () => {
  const { id: priceListId } = (0,dist/* useParams */.UO)();
  if (!priceListId) {
    return /* @__PURE__ */ react.createElement(dist/* Navigate */.Fg, {
      to: (0,routing_links/* linkToPriceListHome */.o0)()
    });
  }
  return /* @__PURE__ */ react.createElement(PageLayout_Page, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.createCustomItems.header.title",
    defaultMessage: "Custom Items List"
  })), /* @__PURE__ */ react.createElement(CreateCustomItemsPage_CreateCustomItemsForm, {
    priceListId
  }));
};
/* harmony default export */ const CreateCustomItemsPage_CreateCustomItemsPage = (CreateCustomItemsPage);

;// CONCATENATED MODULE: ./src/client/price-list/pages/CreatePriceListPage/__generated__/CreatePriceListModal.gql.ts


const CreatePriceListModal_gql_defaultOptions = {};
const CreatePriceListDocument = lib/* gql */.Ps`
    mutation createPriceList($facilityId: ID) {
  priceListV2 {
    createPriceList(input: {facilityId: $facilityId}) {
      priceListId
    }
  }
}
    `;
function useCreatePriceListMutation(baseOptions) {
  const options = { ...CreatePriceListModal_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(CreatePriceListDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/TwoButtonModal.tsx






const iconMap = {
  warning: { src: warningIcon_namespaceObject, alt: "warning" }
};
const TwoButtonModal_Header = (0,styled/* default */.Z)(mui_modal_dist_module/* ModalHeader */.xB)(({ theme }) => ({
  gap: theme.spacing(2)
}));
const Body = (0,styled/* default */.Z)(mui_modal_dist_module/* ModalBody */.fe)(({ theme }) => ({
  padding: theme.spacing(3)
}));
const Footer = (0,styled/* default */.Z)(mui_modal_dist_module/* ModalFooter */.mz)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  padding: theme.spacing(3)
}));
const TwoButtonModal = ({
  icon,
  title,
  primaryButtonText,
  onPrimaryButtonClicked,
  onSecondaryButtonClicked,
  secondaryButtonText,
  children,
  ...delegateProps
}) => {
  const iconProps = iconMap[icon];
  return /* @__PURE__ */ react.createElement(mui_modal_dist_module/* Modal */.u_, {
    ...delegateProps
  }, /* @__PURE__ */ react.createElement(TwoButtonModal_Header, null, /* @__PURE__ */ react.createElement("img", {
    ...iconProps
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h5"
  }, title)), /* @__PURE__ */ react.createElement(Body, null, children), /* @__PURE__ */ react.createElement(Footer, null, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: onSecondaryButtonClicked,
    "data-testid": "components.twoButtonModal.cancel"
  }, secondaryButtonText || /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "components.twoButtonModal.cancel",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    onClick: onPrimaryButtonClicked,
    "data-testid": "components.twoButtonModal.accept"
  }, primaryButtonText || /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "components.twoButtonModal.accept",
    defaultMessage: "Accept"
  }))));
};
/* harmony default export */ const Modals_TwoButtonModal = (TwoButtonModal);

;// CONCATENATED MODULE: ./src/client/price-list/components/Modals/index.ts


;// CONCATENATED MODULE: ./src/client/price-list/pages/CreatePriceListPage/CreatePriceListModal.tsx










lib/* gql */.Ps`
  mutation createPriceList($facilityId: ID) {
    priceListV2 {
      createPriceList(input: { facilityId: $facilityId }) {
        priceListId
      }
    }
  }
`;
const CreatePriceListModal = () => {
  const navigate = (0,dist/* useNavigate */.s0)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { facilityId, roleName } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const isAdmin = roleName === "admin";
  const [createPriceList] = useCreatePriceListMutation({
    variables: {
      facilityId: isAdmin ? null : facilityId
    },
    onCompleted: (res) => {
      dist_default().success(
        formatMessage({
          id: "pricelist.createPriceList.success",
          defaultMessage: "Successfully created price list"
        })
      );
      navigate(`/price-list/${res.priceListV2.createPriceList.priceListId}`);
    },
    onError: () => {
      dist_default().error(
        formatMessage({
          id: "priceList.createPriceList.error.msg",
          defaultMessage: "Failed to create Price List"
        })
      );
    }
  });
  const title = isAdmin ? formatMessage({
    id: "pricelist.modal.createPriceList.modal.organisation.title",
    defaultMessage: "Create Organisation Price List"
  }) : formatMessage({
    id: "pricelist.modal.createPriceList.modal.facility.title",
    defaultMessage: "Create Facility Price List"
  });
  return /* @__PURE__ */ react.createElement(Modals_TwoButtonModal, {
    open: true,
    icon: "warning",
    title,
    primaryButtonText: formatMessage({
      id: "priceList.modal.createPriceList.accept",
      defaultMessage: "Create Price List"
    }),
    onPrimaryButtonClicked: createPriceList,
    onSecondaryButtonClicked: () => navigate((0,routes_links/* linkToHome */.J4)())
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "pricelist.modal.createPriceList.description",
    defaultMessage: "You do not have a price list yet. Would you like to create one?"
  }))));
};
/* harmony default export */ const CreatePriceListPage_CreatePriceListModal = (CreatePriceListModal);

;// CONCATENATED MODULE: ./src/client/price-list/pages/CreatePriceListPage/CreatePriceListPage.tsx


const CreatePriceListPage = () => {
  return /* @__PURE__ */ react.createElement(CreatePriceListPage_CreatePriceListModal, null);
};
/* harmony default export */ const CreatePriceListPage_CreatePriceListPage = (CreatePriceListPage);

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-loading-layout@0.4.0_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-loading-layout/dist/module.js
var mui_loading_layout_dist_module = __webpack_require__(69638);
;// CONCATENATED MODULE: ./src/client/price-list/pages/Root/__generated__/Root.gql.ts


const Root_gql_defaultOptions = {};
const CheckIfHasPriceListDocument = lib/* gql */.Ps`
    query checkIfHasPriceList($facilityId: ID) {
  priceListV2 {
    priceListMeta(input: {facilityId: $facilityId}) {
      id
    }
  }
}
    `;
function useCheckIfHasPriceListQuery(baseOptions) {
  const options = { ...Root_gql_defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(CheckIfHasPriceListDocument, options);
}
function useCheckIfHasPriceListLazyQuery(baseOptions) {
  const options = { ...Root_gql_defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(CheckIfHasPriceListDocument, options);
}

;// CONCATENATED MODULE: ./src/client/price-list/pages/Root/Root.tsx







lib/* gql */.Ps`
  query checkIfHasPriceList($facilityId: ID) {
    priceListV2 {
      priceListMeta(input: { facilityId: $facilityId }) {
        id
      }
    }
  }
`;
const Root = () => {
  const navigate = (0,dist/* useNavigate */.s0)();
  const { facilityId, roleName } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const { data, loading } = useCheckIfHasPriceListQuery({
    variables: { facilityId: roleName === "admin" ? null : facilityId }
  });
  (0,react.useEffect)(() => {
    var _a;
    if (!loading && data) {
      if ((_a = data.priceListV2.priceListMeta) == null ? void 0 : _a.id) {
        navigate((0,routing_links/* linkToPriceList */.EF)(data.priceListV2.priceListMeta.id));
      } else {
        navigate((0,routing_links/* linkToCreatePriceList */.xV)());
      }
    }
  }, [data, loading]);
  return /* @__PURE__ */ react.createElement(mui_loading_layout_dist_module/* FullPageLoading */.F, null);
};
/* harmony default export */ const Root_Root = (Root);

;// CONCATENATED MODULE: ./src/client/price-list/pages/Root/index.ts


// EXTERNAL MODULE: ./src/client/components/Layout/Header/index.tsx + 1 modules
var Layout_Header = __webpack_require__(14187);
;// CONCATENATED MODULE: ./src/client/price-list/components/PageLayout/images/elephant-logo-white-242px_50px.png
const elephant_logo_white_242px_50px_namespaceObject = __webpack_require__.p + "assets/elephant-logo-white-242px_50px.png";
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-link@0.2.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-link/dist/module.js
var mui_link_dist_module = __webpack_require__(40252);
;// CONCATENATED MODULE: ./src/client/price-list/components/PageLayout/HeaderLeftContent.tsx






const HeaderLeftContent_useStyles = (0,makeStyles/* default */.Z)(() => ({
  logo: {
    width: "150px"
  }
}));
const HeaderLeftContent = () => {
  const classes = HeaderLeftContent_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */ react.createElement(mui_link_dist_module/* UnstyledLink */.H, {
    to: (0,routes_links/* linkToHome */.J4)()
  }, /* @__PURE__ */ react.createElement("img", {
    src: elephant_logo_white_242px_50px_namespaceObject,
    alt: formatMessage({
      id: "header.logo",
      defaultMessage: "elephant"
    }),
    className: classes.logo
  }));
};
/* harmony default export */ const PageLayout_HeaderLeftContent = (HeaderLeftContent);

;// CONCATENATED MODULE: ./src/client/price-list/index.tsx













const PRICE_LIST_ROLES = [role_definitions_dist_module/* Role.ADMIN */.uU.ADMIN, role_definitions_dist_module/* Role.CLINIC */.uU.CLINIC, role_definitions_dist_module/* Role.ELEPHANT */.uU.ELEPHANT];
const ADD_ITEMS_ROLES = [role_definitions_dist_module/* Role.ADMIN */.uU.ADMIN, role_definitions_dist_module/* Role.CLINIC */.uU.CLINIC, role_definitions_dist_module/* Role.ELEPHANT */.uU.ELEPHANT];
const Layout = () => /* @__PURE__ */ react.createElement(ex_web_packages.LayoutWithSideMenu, null, /* @__PURE__ */ react.createElement(Layout_Header/* default */.Z, {
  leftContent: /* @__PURE__ */ react.createElement(PageLayout_HeaderLeftContent, null)
}), /* @__PURE__ */ react.createElement(dist/* Outlet */.j3, null));
const PriceListRoutes = () => /* @__PURE__ */ react.createElement(ErrorBoundary/* default */.Z, {
  name: "price-list"
}, /* @__PURE__ */ react.createElement(dist/* Routes */.Z5, null, /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
  path: "*",
  element: /* @__PURE__ */ react.createElement(Layout, null)
}, /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
  index: true,
  element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
    only: PRICE_LIST_ROLES
  }, /* @__PURE__ */ react.createElement(Root_Root, null))
}), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
  path: "create",
  element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
    only: PRICE_LIST_ROLES
  }, /* @__PURE__ */ react.createElement(CreatePriceListPage_CreatePriceListPage, null))
}), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
  path: ":id"
}, /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
  index: true,
  element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
    only: PRICE_LIST_ROLES
  }, /* @__PURE__ */ react.createElement(PriceListPage_PriceListPage, null))
}), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
  path: "add-prices",
  element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
    only: ADD_ITEMS_ROLES
  }, /* @__PURE__ */ react.createElement(AddItemsPage_AddItemsPage, null))
}), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
  path: "create-custom-items",
  element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
    only: ADD_ITEMS_ROLES
  }, /* @__PURE__ */ react.createElement(CreateCustomItemsPage_CreateCustomItemsPage, null))
})))));

// EXTERNAL MODULE: ./src/client/patient-register/routing/Router.tsx + 47 modules
var Router = __webpack_require__(69171);
// EXTERNAL MODULE: ./src/client/inventory/routing/Router.tsx
var routing_Router = __webpack_require__(7897);
// EXTERNAL MODULE: ./src/client/auth/SigningTokenProvider/SigningTokenProvider.tsx + 1 modules
var SigningTokenProvider = __webpack_require__(48462);
// EXTERNAL MODULE: ./src/client/observability/ObservabilityContext.ts
var ObservabilityContext = __webpack_require__(50527);
// EXTERNAL MODULE: ./src/client/observability/ObservabilityProvider.tsx
var ObservabilityProvider = __webpack_require__(91005);
// EXTERNAL MODULE: ./src/client/components/Overlays/Overlays.tsx
var Overlays = __webpack_require__(91829);
;// CONCATENATED MODULE: ./src/client/routes/index.tsx













































const OrganisationManagement = (0,react.lazy)(
  () => Promise.all(/* import() | OrganisationManagement */[__webpack_require__.e(9941), __webpack_require__.e(8938), __webpack_require__.e(4933)]).then(__webpack_require__.bind(__webpack_require__, 23915))
);
const SkuManagement = (0,react.lazy)(
  () => Promise.all(/* import() | SkuManagement */[__webpack_require__.e(4848), __webpack_require__.e(8964)]).then(__webpack_require__.bind(__webpack_require__, 80825))
);
const ClinicalProductManagementRouter = (0,react.lazy)(
  () => __webpack_require__.e(/* import() | ClinicalProductManagement */ 5909).then(__webpack_require__.bind(__webpack_require__, 15492))
);
const ReissuePassport = (0,react.lazy)(
  () => __webpack_require__.e(/* import() | ReissuePassport */ 8589).then(__webpack_require__.bind(__webpack_require__, 56207))
);
const EditPatientPage = (0,react.lazy)(
  () => Promise.all(/* import() | EditPatientPage */[__webpack_require__.e(9941), __webpack_require__.e(5299), __webpack_require__.e(8938), __webpack_require__.e(6591), __webpack_require__.e(6471), __webpack_require__.e(2770)]).then(__webpack_require__.bind(__webpack_require__, 81802))
);
const PatientRoutes = (0,react.lazy)(
  () => Promise.all(/* import() | PatientRoutes */[__webpack_require__.e(9941), __webpack_require__.e(3373), __webpack_require__.e(5791), __webpack_require__.e(6591), __webpack_require__.e(7828), __webpack_require__.e(6012), __webpack_require__.e(4534), __webpack_require__.e(2704), __webpack_require__.e(8181), __webpack_require__.e(8300), __webpack_require__.e(4612), __webpack_require__.e(9186), __webpack_require__.e(9741)]).then(__webpack_require__.bind(__webpack_require__, 47103))
);
const RegistrationRoutes = (0,react.lazy)(
  () => Promise.all(/* import() | NewRoutes */[__webpack_require__.e(9941), __webpack_require__.e(4099), __webpack_require__.e(2928), __webpack_require__.e(5299), __webpack_require__.e(8938), __webpack_require__.e(6591), __webpack_require__.e(6471), __webpack_require__.e(3478), __webpack_require__.e(7828), __webpack_require__.e(9341)]).then(__webpack_require__.bind(__webpack_require__, 79951))
);
const AdminRoutes = (0,react.lazy)(
  () => __webpack_require__.e(/* import() | AdminRoutes */ 6410).then(__webpack_require__.bind(__webpack_require__, 77987))
);
const ClinicAdminRoutes = (0,react.lazy)(
  () => __webpack_require__.e(/* import() | ClinicAdminRoutes */ 7446).then(__webpack_require__.bind(__webpack_require__, 59652))
);
const ReissueCard = (0,react.lazy)(
  () => Promise.all(/* import() | ReissueCard */[__webpack_require__.e(4099), __webpack_require__.e(2928), __webpack_require__.e(3478), __webpack_require__.e(3942)]).then(__webpack_require__.bind(__webpack_require__, 34990))
);
const PatientLogin = (0,react.lazy)(
  () => __webpack_require__.e(/* import() | PatientLoginPage */ 1269).then(__webpack_require__.bind(__webpack_require__, 66008))
);
const WardPatientList = react.lazy(
  () => Promise.all(/* import() | WardPatientList */[__webpack_require__.e(3373), __webpack_require__.e(6772)]).then(__webpack_require__.bind(__webpack_require__, 14637))
);
const PatientQueueManagement = react.lazy(
  () => __webpack_require__.e(/* import() | QueueManagementPage */ 6916).then(__webpack_require__.bind(__webpack_require__, 62145))
);
const PatientQueuePage = react.lazy(
  () => __webpack_require__.e(/* import() | PatientQueuePage */ 845).then(__webpack_require__.bind(__webpack_require__, 55889))
);
const PatientSearchRoutes = react.lazy(
  () => __webpack_require__.e(/* import() | PatientSearchRoutes */ 7669).then(__webpack_require__.bind(__webpack_require__, 68279))
);
const ClinicianDashboardPage = (0,react.lazy)(
  () => __webpack_require__.e(/* import() | ClinicianDashboard */ 6155).then(__webpack_require__.bind(__webpack_require__, 14423))
);
const ScanPatientCardPage = (0,react.lazy)(
  () => Promise.all(/* import() | ScanPatientCardPage */[__webpack_require__.e(4099), __webpack_require__.e(2928), __webpack_require__.e(6357)]).then(__webpack_require__.bind(__webpack_require__, 22102))
);
const UserSettingsPage = (0,react.lazy)(
  () => __webpack_require__.e(/* import() | UserSettingsPage */ 7461).then(__webpack_require__.bind(__webpack_require__, 88159))
);
const { ADMIN, CLINIC, ELEPHANT, ROOT } = auth/* Role */.uU;
const PrivateProviders = ({ children }) => {
  const tokenIsValid = useCheckToken();
  const config = (0,dist_module/* useConfig */.ZR)();
  const user = (0,useUser/* useLazyUser */.x)();
  const { emitErrorEvent, emitUxAnalytic } = (0,ObservabilityContext/* useObservabilityContext */.V)();
  if (!tokenIsValid) {
    return /* @__PURE__ */ react.createElement(SignOut/* default */.Z, null);
  }
  return /* @__PURE__ */ react.createElement(uxAnalytics/* UXAnalyticsProvider */.gS, {
    sampleRate: config.uxAnalytics.sampleRate,
    backgroundEmitters: [new NetworkBackgroundUXAnalyticEmitter/* NetworkBackgroundUXAnalyticEmitter */.u()],
    sendAnalytics: emitUxAnalytic
  }, /* @__PURE__ */ react.createElement(featureFlags/* FeatureFlagsProvider */.OH, {
    territory: config.territory,
    userId: user == null ? void 0 : user.userId,
    userEmail: user == null ? void 0 : user.email,
    facilityId: user == null ? void 0 : user.facilityId,
    launchDarklyKey: config.launchdarkly.key,
    launchDarklyRelayUrl: config.launchdarkly.relayUrl,
    emitErrorEvent
  }, /* @__PURE__ */ react.createElement(LocationsContext/* LocationsProvider */.O, null, /* @__PURE__ */ react.createElement(ClinicalSyncStatus/* ClinicalSyncStatusProvider */.OX, null, /* @__PURE__ */ react.createElement(clinical_engine/* ClinicalEngine */.E, null), /* @__PURE__ */ react.createElement(dev_tools/* default */.Z, null), /* @__PURE__ */ react.createElement(routes_ServiceWorkerUpdater, null), /* @__PURE__ */ react.createElement(Freshdesk/* Freshdesk */.m, null), /* @__PURE__ */ react.createElement(Overlays/* Overlays */.A, null), children, /* @__PURE__ */ react.createElement(GlobalAppIssueOverlay/* default */.Z, null)))));
};
const PrivateRoutes = () => {
  return /* @__PURE__ */ react.createElement(dist/* Routes */.Z5, null, /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "clinician/dashboard",
    element: /* @__PURE__ */ react.createElement(ClinicianDashboardPage, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "scan-card",
    element: /* @__PURE__ */ react.createElement(ScanPatientCardPage, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "ward-patient-list",
    element: /* @__PURE__ */ react.createElement(WardPatientList, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "patient-queue-management",
    element: /* @__PURE__ */ react.createElement(PatientQueueManagement, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "queue",
    element: /* @__PURE__ */ react.createElement(PatientQueuePage, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "passport/reissue",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      except: [ADMIN, CLINIC, ROOT]
    }, /* @__PURE__ */ react.createElement(ReissuePassport, null))
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "user-settings",
    element: /* @__PURE__ */ react.createElement(UserSettingsPage, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "edit/patient/*",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      except: [ROOT]
    }, /* @__PURE__ */ react.createElement(EditPatientPage, null))
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "admin/*",
    element: /* @__PURE__ */ react.createElement(AdminRoutes, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "patient/*",
    element: /* @__PURE__ */ react.createElement(PatientRoutes, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "clinic-admin/*",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      only: [CLINIC]
    }, /* @__PURE__ */ react.createElement(ClinicAdminRoutes, null))
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "organisation-management/*",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      only: [ADMIN, CLINIC, ELEPHANT, ROOT]
    }, /* @__PURE__ */ react.createElement(OrganisationManagement, null))
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "patient-search/*",
    element: /* @__PURE__ */ react.createElement(PatientSearchRoutes, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "clinical-product-management/*",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      only: [ELEPHANT]
    }, /* @__PURE__ */ react.createElement(ClinicalProductManagementRouter, null))
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "sku-management/*",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      only: [ELEPHANT]
    }, /* @__PURE__ */ react.createElement(SkuManagement, null))
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "new/*",
    element: /* @__PURE__ */ react.createElement(RegistrationRoutes, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "/card/reissue",
    element: /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, {
      except: [ADMIN, CLINIC, ROOT]
    }, /* @__PURE__ */ react.createElement(ReissueCard, null))
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "price-list/*",
    element: /* @__PURE__ */ react.createElement(PriceListRoutes, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "patient-register/*",
    element: /* @__PURE__ */ react.createElement(Router/* RegistersRoutes */.$, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "inventory/*",
    element: /* @__PURE__ */ react.createElement(routing_Router/* InventoryRoutes */.G, null)
  }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
    path: "*",
    element: /* @__PURE__ */ react.createElement(NotFound/* default */.Z, null)
  }));
};
const RoutingDependantProviders = () => /* @__PURE__ */ react.createElement(Auth0Provider/* default */.Z, null, /* @__PURE__ */ react.createElement(SessionTokenProvider/* SessionTokenProvider */.hW, null, /* @__PURE__ */ react.createElement(ApolloProvider/* ApolloProvider */.e, null, /* @__PURE__ */ react.createElement(SigningTokenProvider/* SigningTokenProvider */.D4, null, /* @__PURE__ */ react.createElement(UserProvider/* BlockingUserProvider */.c, null, /* @__PURE__ */ react.createElement(ObservabilityProvider/* ObservabilityProvider */.S, null, /* @__PURE__ */ react.createElement(TranslationsProvider/* default */.Z, null, /* @__PURE__ */ react.createElement(ErrorBoundary/* default */.Z, {
  name: "root",
  onRetry: () => window.location.reload(),
  renderError: ({ error }) => /* @__PURE__ */ react.createElement(AppLayout/* default */.Z, null, /* @__PURE__ */ react.createElement(ErrorBoundary/* ErrorPage */.m, {
    error,
    onRetry: () => window.location.reload()
  }))
}, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalPortalProvider */.dl, null, /* @__PURE__ */ react.createElement(Context/* GlobalAppIssueContextProvider */.WK, null, /* @__PURE__ */ react.createElement(BrowserSupport/* default */.ZP, null), /* @__PURE__ */ react.createElement(react.Suspense, {
  fallback: /* @__PURE__ */ react.createElement(Loading/* default */.Z, null)
}, /* @__PURE__ */ react.createElement(LocationHistoryProvider/* default */.ZP, null, /* @__PURE__ */ react.createElement(dist/* Outlet */.j3, null))))), /* @__PURE__ */ react.createElement(mui_toast_dist.Toaster, {
  position: "top-right",
  containerStyle: { top: 80 },
  toastOptions: { duration: 5e3 }
})))))))));
const router = (0,react_router_dom_dist/* createBrowserRouter */.aj)(
  (0,dist/* createRoutesFromElements */.i7)(
    /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "*",
      element: /* @__PURE__ */ react.createElement(RoutingDependantProviders, null)
    }, /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      index: true,
      element: /* @__PURE__ */ react.createElement(Home/* default */.Z, null)
    }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "login",
      element: /* @__PURE__ */ react.createElement(Auth0Login/* default */.Z, null)
    }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "sign-out",
      element: /* @__PURE__ */ react.createElement(SignOut/* default */.Z, null)
    }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "signin"
    }, /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "patient/:passportUid",
      element: /* @__PURE__ */ react.createElement(ExternalPassport/* default */.Z, null)
    }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "v2"
    }, /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "patient"
    }, /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      index: true,
      element: /* @__PURE__ */ react.createElement(PatientLogin, null)
    }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: ":shortId",
      element: /* @__PURE__ */ react.createElement(PatientLogin, null)
    })))), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "auth0"
    }, /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "consent",
      element: /* @__PURE__ */ react.createElement(Auth0Consent/* default */.Z, null)
    }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "callback",
      element: /* @__PURE__ */ react.createElement(Auth0Callback/* Auth0Callback */.M, null)
    })), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "unauthorized",
      element: /* @__PURE__ */ react.createElement(Unauthorized/* default */.Z, null)
    }), /* @__PURE__ */ react.createElement(dist/* Route */.AW, {
      path: "*",
      element: /* @__PURE__ */ react.createElement(PrivateProviders, null, /* @__PURE__ */ react.createElement(RequireAuth/* default */.Z, null, /* @__PURE__ */ react.createElement(PrivateRoutes, null)))
    }))
  )
);


/***/ }),

/***/ 82303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Af": () => (/* binding */ linkToSignOut),
/* harmony export */   "J4": () => (/* binding */ linkToHome),
/* harmony export */   "gr": () => (/* binding */ linkToUnauthorized)
/* harmony export */ });
/* unused harmony exports linkTo404, linkToSigninPatient, linkToSigninV2Patient */
function linkToHome() {
  return "/";
}
function linkToSignOut() {
  return "/sign-out";
}
function linkToUnauthorized() {
  return "/unauthorized";
}
function linkTo404() {
  return "/404";
}
function linkToPatientSignIn() {
  return "/signin";
}
function linkToSigninPatient(passportUid = ":passportUid") {
  return `${linkToPatientSignIn()}/patient/${passportUid}`;
}
function linkToSigninV2Patient() {
  return `${linkToPatientSignIn()}/v2/patient`;
}


/***/ }),

/***/ 27738:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NO": () => (/* binding */ ServiceWorkerRegistrationProvider),
/* harmony export */   "Xq": () => (/* binding */ useServiceWorkerRegistration)
/* harmony export */ });
/* unused harmony export ServiceWorkerRegistrationContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23198);
/* harmony import */ var _elephant_healthcare_service_worker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17664);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20589);




const ServiceWorkerRegistrationContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({ registration: null });
const useServiceWorkerRegistration = () => {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ServiceWorkerRegistrationContext);
  return context.registration;
};
const ServiceWorkerRegistrationProvider = ({ children }) => {
  const config = (0,_elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_1__/* .useConfig */ .ZR)();
  const [registration, setRegistration] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const registerWorker = async () => {
      const sponsoredDataEnabled = [_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .TERRITORY.KENYA */ .jQ.KENYA].includes(config.territory);
      if (!("Cypress" in window)) {
        try {
          const registerResult = await (0,_elephant_healthcare_service_worker__WEBPACK_IMPORTED_MODULE_2__/* .registerServiceWorker */ .$)({
            sponsoredDataEnabled,
            sponsoredDataParams: {
              environment: config.environment,
              territory: config.territory
            }
          });
          setRegistration(registerResult);
        } catch (error) {
        }
      }
    };
    registerWorker();
  }, [config]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ServiceWorkerRegistrationContext.Provider, {
    value: { registration }
  }, children);
};


/***/ }),

/***/ 15063:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4548);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86871);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_locale_en_gb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10569);
/* harmony import */ var dayjs_locale_en_gb__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_en_gb__WEBPACK_IMPORTED_MODULE_2__);



dayjs__WEBPACK_IMPORTED_MODULE_0___default().locale("en-gb");
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1___default()));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((dayjs__WEBPACK_IMPORTED_MODULE_0___default()));


/***/ })

}]);